import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../context/AppContext'
import { getRequestOptions, getAxiosConfig, getAxiosConfigWithContentType } from '../helpers/Fetchwrapper'
import axios from 'axios'
import Swal from 'sweetalert2'

const ProductList = () => {
    const { currentUser } = useContext(AppContext)
    const [products, setProducts] = useState([])
    const [loading, setLoading] = useState(false)
    const [searchTerm, setSearchTerm] = useState('')
    const [filterStatus, setFilterStatus] = useState('all')
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [showModal, setShowModal] = useState(false)
    const [showDetailsModal, setShowDetailsModal] = useState(false)
    const [showEditModal, setShowEditModal] = useState(false)
    const [isEditing, setIsEditing] = useState(false)
    const [selectedProduct, setSelectedProduct] = useState(null)
    const [productDetails, setProductDetails] = useState(null)
    const [detailsLoading, setDetailsLoading] = useState(false)
    const [editLoading, setEditLoading] = useState(false)
    const [categories, setCategories] = useState([])
    const [vendors, setVendors] = useState([])
    const [attributeSets, setAttributeSets] = useState([])
    const [pagination, setPagination] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        total_pages: 0,
        has_next_page: false,
        has_prev_page: false,
        from: 0,
        to: 0
    })

    const [productForm, setProductForm] = useState({
        productName: '',
        sku: '',
        slug: '',
        shortDescription: '',
        description: '',
        vendorId: '',
        idCategories: [],
        price: '',
        costPrice: '',
        specialPrice: '',
        specialPriceFromDate: '',
        specialPriceToDate: '',
        quantity: '',
        minQuantity: '',
        weight: '',
        unit: '',
        dimensions: {
            length: '',
            width: '',
            height: ''
        },
                    status: '1',
        hasOptions: 0,
        isFeatured: false,
        trackQuantity: true,
        allowBackorder: false,
        metaTitle: '',
        metaContent: '',
        metaKewords: '',
        tags: '',
        barcode: '',
        images: [],
        variations: []
    })

    const [activeTab, setActiveTab] = useState('basic')
    const [variationAttributes, setVariationAttributes] = useState([])

    useEffect(() => {
        fetchProducts()
        fetchCategories()
        fetchVendors()
        fetchAttributeSets()
    }, [currentPage, searchTerm, filterStatus, itemsPerPage])

    const fetchProducts = () => {
        setLoading(true)
        
        const params = new URLSearchParams({
            page: currentPage.toString(),
            per_page: itemsPerPage.toString(),
            search: searchTerm,
            status: filterStatus,
            sort_by: 'product_id',
            sort_order: 'desc'
        })

        fetch(process.env.REACT_APP_API_URL + "products_list?" + params.toString(), getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success) {
                    setProducts(resp.data || [])
                    setPagination(resp.pagination || {
                        current_page: 1,
                        per_page: 10,
                        total: 0,
                        total_pages: 0,
                        has_next_page: false,
                        has_prev_page: false,
                        from: 0,
                        to: 0
                    })
                } else {
                    console.error('Failed to fetch products:', resp.errorMessage)
                    setProducts([])
                }
            })
            .catch((error) => {
                console.error('Error fetching products:', error)
                setProducts([])
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const fetchCategories = () => {
        fetch(process.env.REACT_APP_API_URL + "categories", getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success) {
                    setCategories(resp.data || [])
                }
            })
            .catch((error) => console.log("Error fetching categories:", error))
    }

    const fetchVendors = () => {
        fetch(process.env.REACT_APP_API_URL + "vendors", getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success) {
                    setVendors(resp.data || [])
                }
            })
            .catch((error) => console.log("Error fetching vendors:", error))
    }

    const fetchAttributeSets = () => {
        fetch(process.env.REACT_APP_API_URL + "attribute_sets", getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success) {
                    setAttributeSets(resp.data || [])
                }
            })
            .catch((error) => console.log("Error fetching attribute sets:", error))
    }

    const handleSearchChange = (value) => {
        setSearchTerm(value)
        setCurrentPage(1)
    }

    const handleFilterChange = (type, value) => {
        if (type === 'status') {
            setFilterStatus(value)
        } else if (type === 'perPage') {
            setItemsPerPage(parseInt(value))
        }
        setCurrentPage(1)
    }

    const handlePageChange = (page) => {
        setCurrentPage(page)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    const getStatusBadge = (status) => {
        // Handle both string and numeric status values
        const statusValue = status?.toString()
        switch (statusValue) {
            case 'active':
            case '1':
                return 'bg-success'
            case 'inactive':
            case '0':
                return 'bg-danger'
            case 'stockout':
            case '3':
                return 'bg-warning'
            default:
                return 'bg-secondary'
        }
    }

    const getStatusText = (status) => {
        // Handle both string and numeric status values
        const statusValue = status?.toString()
        switch (statusValue) {
            case 'active':
            case '1':
                return 'Active'
            case 'inactive':
            case '0':
                return 'Inactive'
            case 'stockout':
            case '3':
                return 'Out of Stock'
            default:
                return 'Unknown'
        }
    }

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A'
        const date = new Date(dateString)
        return date.toLocaleDateString('en-GB')
    }

    const formatPrice = (price) => {
        return `৳${Math.round(price || 0).toLocaleString('en-BD')}`
    }

    const openAddProductModal = () => {
        setProductForm({
            productName: '',
            sku: '',
            slug: '',
            shortDescription: '',
            description: '',
            vendorId: '',
            idCategories: [],
            price: '',
            costPrice: '',
            specialPrice: '',
            specialPriceFromDate: '',
            specialPriceToDate: '',
            quantity: '',
            minQuantity: '',
            weight: '',
            unit: '',
            dimensions: {
                length: '',
                width: '',
                height: ''
            },
            status: '1',
            hasOptions: 0,
            isFeatured: false,
            trackQuantity: true,
            allowBackorder: false,
            metaTitle: '',
            metaContent: '',
            metaKewords: '',
            tags: '',
            barcode: '',
            images: [],
            variations: []
        })
        setVariationAttributes([])
        setActiveTab('basic')
        setIsEditing(false)
        setShowModal(true)
    }

    const openEditProductModal = (product) => {
        // Fetch detailed product information for editing
        fetchProductDetailsForEdit(product.product_id)
    }

        const fetchProductDetailsForEdit = async (productId) => {
        try {
            setEditLoading(true)
            const response = await fetch(process.env.REACT_APP_API_URL + `products_details/${productId}`, getRequestOptions())
            const result = await response.json()
            
            if (result.success) {
                const productData = result.data
                
                // Format categories for the form
                const formattedCategories = productData.categoryIds ? 
                    productData.categoryIds.map(catId => catId.toString()) : []
                
                // Format images for the form
                const formattedImages = productData.productImage ? 
                    productData.productImage.map(img => ({
                        name: img.originalFileName || img.original_file_name,
                        url: `${process.env.REACT_APP_IMAGE_STORAGE}uploads/products/${productId}/${img.originalFileName || img.original_file_name}`,
                        thumbUrl: img.thumbFileName ? `${process.env.REACT_APP_IMAGE_STORAGE}uploads/products/${productId}/${img.thumbFileName}` : null,
                        size: 0, // We don't have file size in the API response
                        type: 'image/jpeg', // Default type
                        product_entity_media_id: img.product_entity_media_id,
                        original_file_name: img.originalFileName || img.original_file_name,
                        thumb_file_name: img.thumbFileName
                    })) : []

        setProductForm({
                    productName: productData.productName || productData.product_name || '',
                    sku: productData.sku || '',
                    slug: productData.slug || '',
                    shortDescription: productData.short_description || '',
                    description: productData.description || '',
                    vendorId: (productData.vendorId || productData.vendor_id || '').toString(),
                    idCategories: formattedCategories,
                    price: productData.price || productData.productPrice?.[0]?.price || '',
                    costPrice: productData.costPrice || productData.cost_price || productData.costPrice || '',
                    specialPrice: productData.specialPrice || productData.special_price || '',
                    specialPriceFromDate: productData.specialPriceFromDate || productData.special_price_from_date || 
                        (productData.product_special_price && productData.product_special_price[0] ? productData.product_special_price[0].priceFrom : '') || '',
                    specialPriceToDate: productData.specialPriceToDate || productData.special_price_to_date || 
                        (productData.product_special_price && productData.product_special_price[0] ? productData.product_special_price[0].priceTo : '') || '',
                    quantity: productData.quantity || productData.availableQty || productData.qty || '',
                    minQuantity: productData.minQuantity || productData.min_quantity || '',
                    weight: productData.weight || '',
                    unit: productData.unit || '',
                    dimensions: {
                        length: productData.length || '',
                        width: productData.width || '',
                        height: productData.height || ''
                    },
                    status: productData.status?.toString() || '1',
                    hasOptions: productData.hasOptions || productData.has_options || 0,
                    isFeatured: productData.is_featured || productData.isFeatured || false,
                    trackQuantity: productData.track_quantity !== undefined ? productData.track_quantity : true,
                    allowBackorder: productData.allow_backorder || productData.allowBackorder || false,
                    metaTitle: productData.metaTitle || productData.meta_title || '',
                    metaContent: productData.metaContent || productData.meta_content || '',
                    metaKewords: productData.metaKewords || productData.meta_kewords || '',
                    tags: productData.tags || '',
                    barcode: productData.barcode || '',
                    images: formattedImages,
                    variations: productData.variations || []
                })
                
                setVariationAttributes(productData.variation_attributes || [])
                setActiveTab('basic')
        setIsEditing(true)
                setSelectedProduct(productData)
        setShowEditModal(true)
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: result.errorMessage || 'Failed to fetch product details!',
                    confirmButtonText: 'OK'
                })
            }
        } catch (error) {
            console.error('Error fetching product details for edit:', error)
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'Something went wrong!',
                confirmButtonText: 'OK'
            })
        } finally {
            setEditLoading(false)
        }
    }

    const handleProductFormChange = (field, value) => {
        if (field.includes('.')) {
            // Handle nested fields like dimensions.length
            const [parent, child] = field.split('.')
            setProductForm(prev => ({
                ...prev,
                [parent]: {
                    ...prev[parent],
                    [child]: value
                }
            }))
        } else {
        setProductForm(prev => ({
            ...prev,
            [field]: value
        }))
        }

        // Auto-generate slug when product name changes
        if (field === 'productName' && value) {
            const generatedSlug = value
                .toLowerCase()
                .replace(/[^a-z0-9\s-]/g, '') // Remove special characters except spaces and hyphens
                .replace(/\s+/g, '-') // Replace spaces with hyphens
                .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
                .replace(/^-|-$/g, '') // Remove leading/trailing hyphens
            setProductForm(prev => ({
                ...prev,
                slug: generatedSlug
            }))
        }
    }

    const handleImageChange = (event) => {
        const files = Array.from(event.target.files)
        setProductForm(prev => ({
            ...prev,
            images: [...prev.images, ...files]
        }))
    }

    const removeImage = async (index) => {
        const imageToRemove = productForm.images[index]
        
        // If it's an existing image (has product_entity_media_id), delete it from the server
        if (imageToRemove.product_entity_media_id && !imageToRemove.url.startsWith('blob:')) {
            try {
                const response = await axios.delete(
                    process.env.REACT_APP_API_URL + `products/orginal_file_delete/${imageToRemove.product_entity_media_id}`,
                    getAxiosConfig()
                )
                
                if (!response.data.success) {
                    console.error('Failed to delete image from server:', response.data.errorMessage)
                }
            } catch (error) {
                console.error('Error deleting image from server:', error)
            }
        }
        
        setProductForm(prev => ({
            ...prev,
            images: prev.images.filter((_, i) => i !== index)
        }))
    }

    const moveImage = (dragIndex, hoverIndex) => {
        const draggedImage = productForm.images[dragIndex]
        const newImages = [...productForm.images]
        newImages.splice(dragIndex, 1)
        newImages.splice(hoverIndex, 0, draggedImage)
        
        setProductForm(prev => ({
            ...prev,
            images: newImages
        }))
    }

    const handleDrop = (e) => {
        e.preventDefault()
        e.stopPropagation()
        
        const files = Array.from(e.dataTransfer.files).filter(file => 
            file.type.startsWith('image/')
        )
        
        if (files.length > 0) {
            setProductForm(prev => ({
                ...prev,
                images: [...prev.images, ...files]
            }))
        }
    }

    const handleDragOver = (e) => {
        e.preventDefault()
        e.stopPropagation()
    }

    const handleDragEnter = (e) => {
        e.preventDefault()
        e.stopPropagation()
    }

    const setPrimaryImage = (index) => {
        if (index === 0) return // Already primary
        
        const newImages = [...productForm.images]
        const primaryImage = newImages.splice(index, 1)[0]
        newImages.unshift(primaryImage)
        
        setProductForm(prev => ({
            ...prev,
            images: newImages
        }))
    }

    const handleTabChange = (tabName) => {
        setActiveTab(tabName)
    }

    const addVariationAttribute = () => {
        setVariationAttributes(prev => [...prev, {
            id: Date.now(),
            name: '',
            options: []
        }])
    }

    const removeVariationAttribute = (index) => {
        setVariationAttributes(prev => prev.filter((_, i) => i !== index))
    }

    const updateVariationAttribute = (index, field, value) => {
        setVariationAttributes(prev => prev.map((attr, i) => 
            i === index ? { ...attr, [field]: value } : attr
        ))
    }

    const addVariationOption = (attributeIndex) => {
        setVariationAttributes(prev => prev.map((attr, i) => 
            i === attributeIndex 
                ? { ...attr, options: [...attr.options, { id: Date.now(), value: '', price: '', quantity: '' }] }
                : attr
        ))
    }

    const removeVariationOption = (attributeIndex, optionIndex) => {
        setVariationAttributes(prev => prev.map((attr, i) => 
            i === attributeIndex 
                ? { ...attr, options: attr.options.filter((_, j) => j !== optionIndex) }
                : attr
        ))
    }

    const updateVariationOption = (attributeIndex, optionIndex, field, value) => {
        setVariationAttributes(prev => prev.map((attr, i) => 
            i === attributeIndex 
                ? { 
                    ...attr, 
                    options: attr.options.map((opt, j) => 
                        j === optionIndex ? { ...opt, [field]: value } : opt
                    )
                }
                : attr
        ))
    }

    const generateVariations = () => {
        const validAttributes = variationAttributes.filter(attr => 
            attr.name && attr.options.length > 0 && attr.options.every(opt => opt.value)
        )
        
        if (validAttributes.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No Valid Attributes',
                text: 'Please add at least one attribute with options to generate variations.',
                confirmButtonText: 'OK'
            })
            return
        }

        // Generate all possible combinations
        const generateCombinations = (attributes, index = 0, current = {}) => {
            if (index === attributes.length) {
                return [current]
            }
            
            const attribute = attributes[index]
            const combinations = []
            
            attribute.options.forEach(option => {
                combinations.push(...generateCombinations(attributes, index + 1, {
                    ...current,
                    [attribute.name]: option
                }))
            })
            
            return combinations
        }

        const combinations = generateCombinations(validAttributes)
        const variations = combinations.map((combo, index) => ({
            id: Date.now() + index,
            attributes: combo,
            sku: `${productForm.sku}-${index + 1}`,
            price: '',
            costPrice: '',
            quantity: '',
            weight: '',
            images: []
        }))

        setProductForm(prev => ({
            ...prev,
            variations: variations
        }))

        Swal.fire({
            icon: 'success',
            title: 'Variations Generated!',
            text: `${variations.length} variations have been created. You can now edit their individual properties.`,
            confirmButtonText: 'OK'
        })
    }

    const updateVariation = (index, field, value) => {
        setProductForm(prev => ({
            ...prev,
            variations: prev.variations.map((variation, i) => 
                i === index ? { ...variation, [field]: value } : variation
            )
        }))
    }

    const submitProduct = async () => {
        try {
            setLoading(true)
            
            const url = isEditing 
                ? process.env.REACT_APP_API_URL + `products_update/${selectedProduct.product_id}`
                : process.env.REACT_APP_API_URL + "products_create"
            
          
            let response
            let result
            
          
                // Use FormData if we have images to upload
            const formData = new FormData()
            
                // Add all required form fields to FormData
                formData.append('productName', productForm.productName || '')
                formData.append('sku', productForm.sku || '')
                formData.append('slug', productForm.slug || '')
                formData.append('shortDescription', productForm.shortDescription || '')
                formData.append('description', productForm.description || '')
                formData.append('vendorId', productForm.vendorId || '')
                formData.append('attributeSetId', '1') // Default attribute set ID
                formData.append('price', productForm.price || '')
                formData.append('costPrice', productForm.costPrice || '')
                formData.append('specialPrice', productForm.specialPrice || '')
                formData.append('specialPriceFromDate', productForm.specialPriceFromDate || '')
                formData.append('specialPriceToDate', productForm.specialPriceToDate || '')
                formData.append('quantity', productForm.quantity || '')
                formData.append('minQuantity', productForm.minQuantity || '')
                formData.append('weight', productForm.weight || '')
                formData.append('unit', productForm.unit || '')
                formData.append('length', productForm.dimensions?.length || '')
                formData.append('width', productForm.dimensions?.width || '')
                formData.append('height', productForm.dimensions?.height || '')
                formData.append('status', productForm.status || '1')
                formData.append('hasOptions', productForm.hasOptions || 0)
                formData.append('isFeatured', productForm.isFeatured ? '1' : '0')
                formData.append('trackQuantity', productForm.trackQuantity ? '1' : '0')
                formData.append('allowBackorder', productForm.allowBackorder ? '1' : '0')
                formData.append('metaTitle', productForm.metaTitle || '')
                formData.append('metaContent', productForm.metaContent || '')
                formData.append('metaKewords', productForm.metaKewords || '')
                formData.append('tags', productForm.tags || '')
                formData.append('barcode', productForm.barcode || '')
                
                // Handle categories array
                if (productForm.idCategories && productForm.idCategories.length > 0) {
                    productForm.idCategories.forEach((categoryId, index) => {
                        formData.append(`idCategories[${index}]`, categoryId)
                    })
                } else {
                    // If no categories selected, send empty array
                    formData.append('idCategories[0]', '')
                }
                
                // Handle images
                    if (productForm.images && productForm.images.length > 0) {
                        productForm.images.forEach((image, index) => {
                        if (image instanceof File) {
                            formData.append(`images[${index}]`, image)
                        } else if (image.url && image.product_entity_media_id) {
                            // This is an existing image, pass the media ID
                            formData.append(`existingImages[${index}]`, image.product_entity_media_id)
                        }
                    })
                }
                
                // Handle variations if any
                if (productForm.variations && productForm.variations.length > 0) {
                    formData.append('variations', JSON.stringify(productForm.variations))
                }
                
                // Handle variation attributes if any
                if (variationAttributes && variationAttributes.length > 0) {
                    formData.append('variationAttributes', JSON.stringify(variationAttributes))
                }
                
                // Use axios for FormData
                const config = getAxiosConfig()
                config.headers['Content-Type'] = 'multipart/form-data'
                
                if (isEditing) {
                    response = await axios.post(url, formData, config)
                } else {
                    response = await axios.post(url, formData, config)
                }
             

            result = response.data

            if (result.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: isEditing ? 'Product updated successfully!' : 'Product created successfully!',
                    confirmButtonText: 'OK'
                })
                
                setShowModal(false)
                setShowEditModal(false)
                fetchProducts()
            } else {
                // Handle validation errors
                if (result.errorMessage && typeof result.errorMessage === 'object') {
                    const errorMessages = Object.values(result.errorMessage)
                        .flat()
                        .join('\n')
                    
                    Swal.fire({
                        icon: 'error',
                        title: 'Validation Error!',
                        text: errorMessages,
                        confirmButtonText: 'OK'
                    })
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: result.errorMessage || 'Something went wrong!',
                    confirmButtonText: 'OK'
                })
                }
            }
        } catch (error) {
            console.error('Error submitting product:', error)
            
            // Handle axios error response
            if (error.response && error.response.data) {
                const errorData = error.response.data
                if (errorData.errorMessage && typeof errorData.errorMessage === 'object') {
                    const errorMessages = Object.values(errorData.errorMessage)
                        .flat()
                        .join('\n')
                    
                    Swal.fire({
                        icon: 'error',
                        title: 'Validation Error!',
                        text: errorMessages,
                        confirmButtonText: 'OK'
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error!',
                        text: errorData.errorMessage || 'Something went wrong!',
                        confirmButtonText: 'OK'
                    })
                }
            } else {
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'Something went wrong!',
                confirmButtonText: 'OK'
            })
            }
        } finally {
            setLoading(false)
        }
    }

    const toggleProductStatus = async (product) => {
        try {
            // Cycle through statuses: 1 (active) -> 0 (inactive) -> 3 (stockout) -> 1 (active)
            let newStatus
            const currentStatus = product.status?.toString()
            switch (currentStatus) {
                case 'active':
                case '1':
                    newStatus = 0 // inactive
                    break
                case 'inactive':
                case '0':
                    newStatus = 3 // stockout
                    break
                case 'stockout':
                case '3':
                    newStatus = 1 // active
                    break
                default:
                    newStatus = 1 // active
            }
            
            const response = await axios.post(
                process.env.REACT_APP_API_URL + `products_status_update/${product.product_id}`,
                { status: newStatus },
                getAxiosConfigWithContentType('application/json')
            )

            if (response.data.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: `Product status updated to ${getStatusText(newStatus)} successfully!`,
                    confirmButtonText: 'OK'
                })
                fetchProducts()
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: response.data.errorMessage || 'Failed to update status!',
                    confirmButtonText: 'OK'
                })
            }
        } catch (error) {
            console.error('Error updating product status:', error)
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'Something went wrong!',
                confirmButtonText: 'OK'
            })
        }
    }

    const viewProductDetails = async (product) => {
        try {
            setDetailsLoading(true)
            setSelectedProduct(product)
            
            const response = await axios.get(
                process.env.REACT_APP_API_URL + `products_details/${product.product_id}`,
                getAxiosConfig()
            )
            
            if (response.data.success) {
                setProductDetails(response.data.data)
                setShowDetailsModal(true)
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: response.data.errorMessage || 'Failed to fetch product details!',
                    confirmButtonText: 'OK'
                })
            }
        } catch (error) {
            console.error('Error fetching product details:', error)
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'Something went wrong!',
                confirmButtonText: 'OK'
            })
        } finally {
            setDetailsLoading(false)
        }
    }

    const deleteProduct = async (product) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to delete "${product.product_name}"?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        })

        if (result.isConfirmed) {
            try {
                const response = await axios.delete(
                    process.env.REACT_APP_API_URL + `products_delete/${product.product_id}`,
                    getAxiosConfig()
                )

                if (response.data.success) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: 'Product has been deleted successfully!',
                        confirmButtonText: 'OK'
                    })
                    fetchProducts()
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error!',
                        text: response.data.errorMessage || 'Failed to delete product!',
                        confirmButtonText: 'OK'
                    })
                }
            } catch (error) {
                console.error('Error deleting product:', error)
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: 'Something went wrong!',
                    confirmButtonText: 'OK'
                })
            }
        }
    }

    return (
        <div className="card">
            <div className="card-header border-0 pt-6">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center w-100">
                    <div className="card-title mb-3 mb-md-0">
                    <h3 className="fw-bold m-0">Product Management</h3>
                        <p className="text-muted mb-0 d-none d-md-block">Manage your product inventory and catalog</p>
                </div>
                <div className="card-toolbar">
                    <button
                        type="button"
                            className="btn btn-primary btn-mobile-full"
                        onClick={openAddProductModal}
                    >
                            <i className="fas fa-plus me-2"></i>
                            <span className="d-none d-sm-inline">Add New </span>Product
                    </button>
                    </div>
                </div>
            </div>

            <div className="card-body border-bottom">
                <div className="row g-3">
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="position-relative">
                            <input
                                type="text"
                                className="form-control form-control-lg ps-12"
                                placeholder="Search products..."
                                value={searchTerm}
                                onChange={(e) => handleSearchChange(e.target.value)}
                            />
                            <div className="position-absolute top-50 start-0 translate-middle-y ps-3">
                                <i className="fas fa-search text-muted"></i>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3">
                        <select
                            className="form-select form-select-lg"
                            value={filterStatus}
                            onChange={(e) => handleFilterChange('status', e.target.value)}
                        >
                            <option value="all">All Status</option>
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                            <option value="3">Out of Stock</option>
                        </select>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3">
                        <select
                            className="form-select form-select-lg"
                            value={itemsPerPage}
                            onChange={(e) => handleFilterChange('perPage', e.target.value)}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                        </select>
                    </div>
                </div>
            </div>

            <div className="card-body">
                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-2">Loading products...</p>
                    </div>
                ) : products.length === 0 ? (
                    <div className="text-center py-5">
                        <i className="fas fa-box fa-3x text-muted mb-3"></i>
                        <h5 className="text-muted">No products found</h5>
                        <p className="text-muted">Try adjusting your search or filters</p>
                    </div>
                ) : (
                    <>
                        {/* Desktop Table View */}
                        <div className="d-none d-lg-block">
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead className="table-light">
                                <tr>
                                    <th>Image</th>
                                    <th>Product Name</th>
                                    <th>SKU</th>
                                    <th>Price</th>
                                    <th>Stock</th>
                                            <th>Unit</th>
                                    <th>Status</th>
                                    <th>Created</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {products.map((product) => (
                                    <tr key={product.product_id}>
                                        <td>
                                            <div className="product-thumbnail">
                                                {product.thumb_file_name ? (
                                                    <img 
                                                        src={`${process.env.REACT_APP_IMAGE_STORAGE}uploads/products/${product.product_id}/${product.thumb_file_name}`}
                                                        alt={product.product_name}
                                                        className="product-thumb-img"
                                                        onError={(e) => {
                                                            e.target.src = '/images/no-image.png';
                                                            e.target.onerror = null;
                                                        }}
                                                    />
                                                ) : (
                                                    <div className="no-image-placeholder">
                                                        <i className="fas fa-image text-muted"></i>
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex flex-column">
                                                <span className="fw-bold text-dark">{product.product_name}</span>
                                               
                                            </div>
                                        </td>
                                        <td>
                                            <span className="badge badge-light-primary">{product.sku}</span>
                                        </td>
                                        <td>
                                            <span className="fw-bold text-success">
                                                {formatPrice(product.price)}
                                            </span>
                                        </td>
                                        <td>
                                            <span className={`badge ${product.qty > 0 ? 'badge-success' : 'badge-danger'}`}>
                                                {product.qty || 0}
                                            </span>
                                        </td>
                                                <td>
                                                    <span className="badge badge-light-info">
                                                        {product.unit || 'N/A'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className={`badge ${getStatusBadge(product.status)}`}>
                                                {getStatusText(product.status)}
                                            </span>
                                        </td>
                                        <td>
                                            <small className="text-muted">
                                                {formatDate(product.created_at)}
                                            </small>
                                        </td>
                                        <td>
                                            <div className="btn-group" role="group">
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-light-primary"
                                                    onClick={() => viewProductDetails(product)}
                                                    title="View Details"
                                                >
                                                    <i className="fas fa-eye"></i>
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-light-warning"
                                                    onClick={() => openEditProductModal(product)}
                                                    title="Edit"
                                                >
                                                    <i className="fas fa-edit"></i>
                                                </button>
                                                <button
                                                    type="button"
                                                    className={`btn btn-sm ${product.status === 'active' ? 'btn-light-danger' : product.status === 'inactive' ? 'btn-light-success' : 'btn-light-warning'}`}
                                                    onClick={() => toggleProductStatus(product)}
                                                    title={`Change status from ${getStatusText(product.status)}`}
                                                >
                                                    <i className={`fas fa-${product.status === 'active' ? 'times' : product.status === 'inactive' ? 'check' : 'exclamation-triangle'}`}></i>
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-light-danger"
                                                    onClick={() => deleteProduct(product)}
                                                    title="Delete"
                                                >
                                                    <i className="fas fa-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                            </div>
                        </div>

                        {/* Mobile Card View */}
                        <div className="d-lg-none">
                            <div className="mobile-products-container">
                                {products.map((product) => (
                                    <div key={product.product_id} className="mobile-product-card">
                                        <div className="product-card-header">
                                            <div className="product-thumbnail-mobile">
                                                {product.thumb_file_name ? (
                                                    <img 
                                                        src={`${process.env.REACT_APP_IMAGE_STORAGE}uploads/products/${product.product_id}/${product.thumb_file_name}`}
                                                        alt={product.product_name}
                                                        className="product-thumb-img-mobile"
                                                        onError={(e) => {
                                                            e.target.src = '/images/no-image.png';
                                                            e.target.onerror = null;
                                                        }}
                                                    />
                                                ) : (
                                                    <div className="no-image-placeholder-mobile">
                                                        <i className="fas fa-image text-muted"></i>
                    </div>
                                                )}
                                            </div>
                                            <div className="product-title-section">
                                                <h6 className="product-name mb-1">{product.product_name}</h6>
                                                <div className="product-meta">
                                                    <span className="sku-badge">{product.sku}</span>
                                                    <span className={`status-badge ${getStatusBadge(product.status)}`}>
                                                        {getStatusText(product.status)}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="product-price">
                                                <span className="price-text">{formatPrice(product.price)}</span>
                                            </div>
                                        </div>
                                        
                                        <div className="product-card-body">
                                            <div className="product-stats">
                                                <div className="stat-item">
                                                    <i className="fas fa-cubes text-muted"></i>
                                                    <span className="stat-label">Stock:</span>
                                                    <span className={`stat-value ${product.qty > 0 ? 'text-success' : 'text-danger'}`}>
                                                        {product.qty || 0}
                                                    </span>
                                                </div>
                                                <div className="stat-item">
                                                    <i className="fas fa-weight text-muted"></i>
                                                    <span className="stat-label">Unit:</span>
                                                    <span className="stat-value">{product.unit || 'N/A'}</span>
                                                </div>
                                                <div className="stat-item">
                                                    <i className="fas fa-calendar text-muted"></i>
                                                    <span className="stat-label">Created:</span>
                                                    <span className="stat-value">{formatDate(product.created_at)}</span>
                                                </div>
                                            </div>
                                            
                                            {product.attribute_set && (
                                                <div className="product-attributes">
                                                    <small className="text-muted">{product.attribute_set}</small>
                    </div>
                                            )}
                                        </div>
                                        
                                        <div className="product-card-actions d-flex flex-wrap gap-1">
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-primary"
                                                onClick={() => viewProductDetails(product)}
                                            >
                                                <i className="fas fa-eye me-1"></i>
                                                View
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-warning"
                                                onClick={() => openEditProductModal(product)}
                                            >
                                                <i className="fas fa-edit me-1"></i>
                                                Edit
                                            </button>
                                            <button
                                                type="button"
                                                className={`btn btn-sm ${product.status === 'active' ? 'btn-outline-danger' : product.status === 'inactive' ? 'btn-outline-success' : 'btn-outline-warning'}`}
                                                onClick={() => toggleProductStatus(product)}
                                            >
                                                <i className={`fas fa-${product.status === 'active' ? 'times' : product.status === 'inactive' ? 'check' : 'exclamation-triangle'} me-1`}></i>
                                                <span className="d-none d-sm-inline">
                                                    {product.status === 'active' ? 'Deactivate' : product.status === 'inactive' ? 'Activate' : 'Change Status'}
                                                </span>
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => deleteProduct(product)}
                                            >
                                                <i className="fas fa-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </>
                )}

                {pagination.total_pages > 1 && (
                    <div className="pagination-container mt-4">
                        <div className="pagination-info text-center text-md-start mb-3 mb-md-0">
                            <small className="text-muted">
                            Showing {pagination.from} to {pagination.to} of {pagination.total} entries
                            </small>
                        </div>
                        <nav className="d-flex justify-content-center">
                            <ul className="pagination pagination-mobile">
                                <li className={`page-item ${!pagination.has_prev_page ? 'disabled' : ''}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(pagination.current_page - 1)}
                                        disabled={!pagination.has_prev_page}
                                    >
                                        <i className="fas fa-chevron-left d-md-none"></i>
                                        <span className="d-none d-md-inline">Previous</span>
                                    </button>
                                </li>
                                
                                {/* Mobile: Show only current, prev, and next page numbers */}
                                <div className="d-md-none d-flex">
                                    {pagination.current_page > 1 && (
                                        <li className="page-item">
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(pagination.current_page - 1)}
                                            >
                                                {pagination.current_page - 1}
                                            </button>
                                        </li>
                                    )}
                                    <li className="page-item active">
                                        <button className="page-link">
                                            {pagination.current_page}
                                        </button>
                                    </li>
                                    {pagination.current_page < pagination.total_pages && (
                                        <li className="page-item">
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(pagination.current_page + 1)}
                                            >
                                                {pagination.current_page + 1}
                                            </button>
                                        </li>
                                    )}
                                </div>
                                
                                {/* Desktop: Show all page numbers */}
                                <div className="d-none d-md-flex">
                                    {Array.from({ length: Math.min(pagination.total_pages, 10) }, (_, i) => {
                                        let page;
                                        if (pagination.total_pages <= 10) {
                                            page = i + 1;
                                        } else {
                                            const start = Math.max(1, pagination.current_page - 5);
                                            const end = Math.min(pagination.total_pages, start + 9);
                                            page = start + i;
                                            if (page > end) return null;
                                        }
                                        return (
                                    <li key={page} className={`page-item ${page === pagination.current_page ? 'active' : ''}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(page)}
                                        >
                                            {page}
                                        </button>
                                    </li>
                                        );
                                    })}
                                </div>
                                
                                <li className={`page-item ${!pagination.has_next_page ? 'disabled' : ''}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(pagination.current_page + 1)}
                                        disabled={!pagination.has_next_page}
                                    >
                                        <i className="fas fa-chevron-right d-md-none"></i>
                                        <span className="d-none d-md-inline">Next</span>
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                )}
            </div>

            {/* Add/Edit Product Modal */}
            {(showModal || showEditModal) && (
                <div className={`modal fade show d-block ${showModal || showEditModal ? 'modal-adaptive product-modal' : ''}`} 
                     style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                    <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            {editLoading && (
                                <div className="modal-loading-overlay">
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mt-2">Loading product details...</p>
                                    </div>
                                </div>
                            )}
                            <div className="modal-header sticky-top bg-white border-bottom">
                                <div className="modal-title-wrapper">
                                    <h4 className="modal-title mb-0">
                                        <i className={`fas ${isEditing ? 'fa-edit' : 'fa-plus-circle'} text-primary me-2`}></i>
                                    {isEditing ? 'Edit Product' : 'Add New Product'}
                                    </h4>
                                    <p className="text-muted mb-0 mt-1">
                                        {isEditing ? 'Update product information and settings' : 'Create a new product with all necessary details'}
                                    </p>
                                </div>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setShowModal(false)
                                        setShowEditModal(false)
                                    }}
                                ></button>
                            </div>
                            <div className="modal-body p-0">
                                {/* Tab Navigation */}
                                <div className="product-tabs-container">
                                    <ul className="nav nav-tabs product-tabs" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button 
                                                className={`nav-link ${activeTab === 'basic' ? 'active' : ''}`}
                                                onClick={() => handleTabChange('basic')}
                                                type="button"
                                            >
                                                <i className="fas fa-info-circle me-2"></i>
                                                Basic Information
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button 
                                                className={`nav-link ${activeTab === 'pricing' ? 'active' : ''}`}
                                                onClick={() => handleTabChange('pricing')}
                                                type="button"
                                            >
                                                <i className="fas fa-dollar-sign me-2"></i>
                                                Pricing & Inventory
                                            </button>
                                        </li>

                                        <li className="nav-item" role="presentation">
                                            <button 
                                                className={`nav-link ${activeTab === 'images' ? 'active' : ''}`}
                                                onClick={() => handleTabChange('images')}
                                                type="button"
                                            >
                                                <i className="fas fa-images me-2"></i>
                                                Images
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button 
                                                className={`nav-link ${activeTab === 'variations' ? 'active' : ''}`}
                                                onClick={() => handleTabChange('variations')}
                                                type="button"
                                                disabled={productForm.hasOptions === 0}
                                            >
                                                <i className="fas fa-cubes me-2"></i>
                                                Variations
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button 
                                                className={`nav-link ${activeTab === 'seo' ? 'active' : ''}`}
                                                onClick={() => handleTabChange('seo')}
                                                type="button"
                                            >
                                                <i className="fas fa-search me-2"></i>
                                                SEO & Marketing
                                            </button>
                                        </li>
                                    </ul>
                                </div>

                                {/* Tab Content */}
                                <div className="tab-content product-tab-content">
                                    {/* Basic Information Tab */}
                                    <div className={`tab-pane fade ${activeTab === 'basic' ? 'show active' : ''}`} id="basic" role="tabpanel">
                                        <div className="tab-pane-content">
                                            <div className="section-header">
                                                <h6 className="section-title">
                                                    <i className="fas fa-info-circle text-primary me-2"></i>
                                                    Product Details
                                                </h6>
                                                <p className="section-description">
                                                    Enter the basic information about your product
                                                </p>
                                            </div>
                                <div className="row g-4">
                                                {/* Product Name */}
                                                <div className="col-12">
                                        <div className="form-group">
                                                        <label className="form-label required">
                                                            <i className="fas fa-tag text-muted me-2"></i>
                                                            Product Name
                                                        </label>
                                            <input
                                                type="text"
                                                            className="form-control form-control-lg"
                                                value={productForm.productName}
                                                onChange={(e) => handleProductFormChange('productName', e.target.value)}
                                                            placeholder="Enter a descriptive product name"
                                            />
                                        </div>
                                    </div>

                                                {/* SKU and Barcode */}
                                    <div className="col-md-6">
                                        <div className="form-group">
                                                        <label className="form-label required">
                                                            <i className="fas fa-barcode text-muted me-2"></i>
                                                            SKU (Stock Keeping Unit)
                                                        </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={productForm.sku}
                                                onChange={(e) => handleProductFormChange('sku', e.target.value)}
                                                            placeholder="e.g., PROD-001"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                                        <label className="form-label">
                                                            <i className="fas fa-qrcode text-muted me-2"></i>
                                                            Barcode
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={productForm.barcode}
                                                            onChange={(e) => handleProductFormChange('barcode', e.target.value)}
                                                            placeholder="Product barcode (optional)"
                                                        />
                                                    </div>
                                                </div>

                                                {/* Slug */}
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <label className="form-label">
                                                            <i className="fas fa-link text-muted me-2"></i>
                                                            URL Slug
                                                        </label>
                                                        <div className="input-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={productForm.slug}
                                                onChange={(e) => handleProductFormChange('slug', e.target.value)}
                                                                placeholder="product-url-slug (auto-generated from product name)"
                                                            />
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-secondary"
                                                                onClick={() => {
                                                                    if (productForm.productName) {
                                                                        const generatedSlug = productForm.productName
                                                                            .toLowerCase()
                                                                            .replace(/[^a-z0-9\s-]/g, '')
                                                                            .replace(/\s+/g, '-')
                                                                            .replace(/-+/g, '-')
                                                                            .replace(/^-|-$/g, '')
                                                                        handleProductFormChange('slug', generatedSlug)
                                                                    }
                                                                }}
                                                                title="Regenerate slug from product name"
                                                            >
                                                                <i className="fas fa-sync-alt"></i>
                                                            </button>
                                        </div>
                                                        <small className="form-text text-muted">
                                                            <i className="fas fa-info-circle me-1"></i>
                                                            Auto-generated from product name. You can edit manually or regenerate.
                                                        </small>
                                    </div>
                                                </div>



                                                {/* Full Description */}
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <label className="form-label">
                                                            <i className="fas fa-file-alt text-muted me-2"></i>
                                                            Full Description
                                                        </label>
                                                        <div className="rich-text-editor-container">
                                                            <div className="editor-toolbar">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary me-1"
                                                                    onClick={() => document.execCommand('bold', false, null)}
                                                                    title="Bold"
                                                                >
                                                                    <i className="fas fa-bold"></i>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary me-1"
                                                                    onClick={() => document.execCommand('italic', false, null)}
                                                                    title="Italic"
                                                                >
                                                                    <i className="fas fa-italic"></i>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary me-1"
                                                                    onClick={() => document.execCommand('underline', false, null)}
                                                                    title="Underline"
                                                                >
                                                                    <i className="fas fa-underline"></i>
                                                                </button>
                                                                <div className="btn-group me-1" role="group">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-outline-secondary"
                                                                        onClick={() => document.execCommand('insertUnorderedList', false, null)}
                                                                        title="Bullet List"
                                                                    >
                                                                        <i className="fas fa-list-ul"></i>
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-outline-secondary"
                                                                        onClick={() => document.execCommand('insertOrderedList', false, null)}
                                                                        title="Numbered List"
                                                                    >
                                                                        <i className="fas fa-list-ol"></i>
                                                                    </button>
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary me-1"
                                                                    onClick={() => document.execCommand('createLink', false, prompt('Enter URL:'))}
                                                                    title="Insert Link"
                                                                >
                                                                    <i className="fas fa-link"></i>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary me-1"
                                                                    onClick={() => document.execCommand('justifyLeft', false, null)}
                                                                    title="Align Left"
                                                                >
                                                                    <i className="fas fa-align-left"></i>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary me-1"
                                                                    onClick={() => document.execCommand('justifyCenter', false, null)}
                                                                    title="Align Center"
                                                                >
                                                                    <i className="fas fa-align-center"></i>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary me-1"
                                                                    onClick={() => document.execCommand('justifyRight', false, null)}
                                                                    title="Align Right"
                                                                >
                                                                    <i className="fas fa-align-right"></i>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary"
                                                                    onClick={() => {
                                                                        const editor = document.getElementById('description-editor')
                                                                        editor.innerHTML = ''
                                                                        handleProductFormChange('description', '')
                                                                    }}
                                                                    title="Clear All"
                                                                >
                                                                    <i className="fas fa-eraser"></i>
                                                                </button>
                                                            </div>
                                                            <div
                                                                id="description-editor"
                                                                className="form-control rich-text-editor"
                                                                contentEditable="true"
                                                                dangerouslySetInnerHTML={{ __html: productForm.description }}
                                                                onInput={(e) => handleProductFormChange('description', e.target.innerHTML)}
                                                                onBlur={(e) => handleProductFormChange('description', e.target.innerHTML)}
                                                                placeholder="Detailed product description with features, specifications, etc. Use the toolbar above to format your text."
                                                            ></div>
                                                            <div className="editor-footer">
                                                                <small className="text-muted">
                                                                    <i className="fas fa-info-circle me-1"></i>
                                                                    Use the toolbar to format your text. HTML formatting is supported.
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Categories */}
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <label className="form-label required">
                                                            <i className="fas fa-sitemap text-muted me-2"></i>
                                                            Categories
                                                        </label>
                                                        <div className="categories-multiselect">
                                                            <div className="categories-search mb-2">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    placeholder="Search categories..."
                                                                    onChange={(e) => {
                                                                        const searchTerm = e.target.value.toLowerCase()
                                                                        const checkboxes = document.querySelectorAll('.category-checkbox-container')
                                                                        checkboxes.forEach(container => {
                                                                            const label = container.querySelector('label').textContent.toLowerCase()
                                                                            container.style.display = label.includes(searchTerm) ? 'block' : 'none'
                                                                        })
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="categories-list border rounded p-3" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                                                {categories.map((category) => (
                                                                    <div key={category.id_categories} className="category-checkbox-container mb-2">
                                                                        <div className="form-check">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                id={`category-${category.id_categories}`}
                                                                                checked={productForm.idCategories.includes(category.id_categories.toString())}
                                                                                onChange={(e) => {
                                                                                    const categoryId = category.id_categories.toString()
                                                                                    let updatedCategories = [...productForm.idCategories]
                                                                                    
                                                                                    if (e.target.checked) {
                                                                                        if (!updatedCategories.includes(categoryId)) {
                                                                                            updatedCategories.push(categoryId)
                                                                                        }
                                                                                    } else {
                                                                                        updatedCategories = updatedCategories.filter(id => id !== categoryId)
                                                                                    }
                                                                                    
                                                                                    handleProductFormChange('idCategories', updatedCategories)
                                                                                }}
                                                                            />
                                                                            <label className="form-check-label" htmlFor={`category-${category.id_categories}`}>
                                                                                {category.category_name}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            {productForm.idCategories.length > 0 && (
                                                                <div className="selected-categories mt-2">
                                                                    <small className="text-muted">Selected categories:</small>
                                                                    <div className="mt-1">
                                                                        {productForm.idCategories.map(categoryId => {
                                                                            const category = categories.find(c => c.id_categories.toString() === categoryId)
                                                                            return category ? (
                                                                                <span key={categoryId} className="badge bg-primary me-1 mb-1">
                                                                                    {category.category_name}
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn-close btn-close-white ms-1"
                                                                                        style={{ fontSize: '0.6rem' }}
                                                                                        onClick={() => {
                                                                                            const updatedCategories = productForm.idCategories.filter(id => id !== categoryId)
                                                                                            handleProductFormChange('idCategories', updatedCategories)
                                                                                        }}
                                                                                    ></button>
                                                                                </span>
                                                                            ) : null
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Vendor and Product Type */}
                                    <div className="col-md-6">
                                        <div className="form-group">
                                                        <label className="form-label required">
                                                            <i className="fas fa-store text-muted me-2"></i>
                                                            Vendor
                                                        </label>
                                            <select
                                                className="form-select"
                                                value={productForm.vendorId}
                                                onChange={(e) => handleProductFormChange('vendorId', e.target.value)}
                                            >
                                                <option value="">Select Vendor</option>
                                                {vendors.map((vendor) => (
                                                    <option key={vendor.vendor_id} value={vendor.vendor_id}>
                                                        {vendor.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                                        <label className="form-label">
                                                            <i className="fas fa-cube text-muted me-2"></i>
                                                            Product Type
                                                        </label>
                                            <select
                                                className="form-select"
                                                            value={productForm.hasOptions}
                                                            onChange={(e) => handleProductFormChange('hasOptions', parseInt(e.target.value))}
                                                        >
                                                            <option value={0}>Simple Product</option>
                                                            <option value={1}>Configurable Product (with variations)</option>
                                            </select>
                                        </div>
                                    </div>

                                                {/* Status and Featured */}
                                    <div className="col-md-6">
                                        <div className="form-group">
                                                        <label className="form-label">
                                                            <i className="fas fa-toggle-on text-muted me-2"></i>
                                                            Status
                                                        </label>
                                            <select
                                                className="form-select"
                                                            value={productForm.status}
                                                            onChange={(e) => handleProductFormChange('status', e.target.value)}
                                            >
                                                            <option value="1">Active</option>
                                                            <option value="0">Inactive</option>
                                                            <option value="3">Out of Stock</option>
                                            </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">&nbsp;</label>
                                                        <div className="form-check form-switch">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id="isFeatured"
                                                                checked={productForm.isFeatured}
                                                                onChange={(e) => handleProductFormChange('isFeatured', e.target.checked)}
                                                            />
                                                            <label className="form-check-label" htmlFor="isFeatured">
                                                                <i className="fas fa-star text-warning me-2"></i>
                                                                Featured Product
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Pricing & Inventory Tab */}
                                    <div className={`tab-pane fade ${activeTab === 'pricing' ? 'show active' : ''}`} id="pricing" role="tabpanel">
                                        <div className="tab-pane-content">
                                            <div className="section-header">
                                                <h6 className="section-title">
                                                    <i className="fas fa-dollar-sign text-primary me-2"></i>
                                                    Pricing Information
                                                </h6>
                                                <p className="section-description">
                                                    Set regular and special pricing for your product
                                                </p>
                                            </div>
                                            <div className="row g-4">

                                                {/* Regular Price */}
                                    <div className="col-md-4">
                                        <div className="form-group">
                                                        <label className="form-label required">
                                                            <i className="fas fa-dollar-sign text-success me-2"></i>
                                                            Regular Price
                                                        </label>
                                                        <div className="input-group">
                                                            <span className="input-group-text">৳</span>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={productForm.price}
                                                onChange={(e) => handleProductFormChange('price', e.target.value)}
                                                placeholder="0.00"
                                                step="0.01"
                                            />
                                        </div>
                                    </div>
                                                </div>

                                                {/* Cost Price */}
                                    <div className="col-md-4">
                                        <div className="form-group">
                                                        <label className="form-label required">
                                                            <i className="fas fa-receipt text-warning me-2"></i>
                                                            Cost Price
                                                        </label>
                                                        <div className="input-group">
                                                            <span className="input-group-text">৳</span>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={productForm.costPrice}
                                                onChange={(e) => handleProductFormChange('costPrice', e.target.value)}
                                                placeholder="0.00"
                                                step="0.01"
                                            />
                                        </div>
                                    </div>
                                                </div>

                                                {/* Special Price */}
                                    <div className="col-md-4">
                                        <div className="form-group">
                                                        <label className="form-label">
                                                            <i className="fas fa-percentage text-danger me-2"></i>
                                                            Special Price
                                                        </label>
                                                        <div className="input-group">
                                                            <span className="input-group-text">৳</span>
                                            <input
                                                type="number"
                                                className="form-control"
                                                                value={productForm.specialPrice}
                                                                onChange={(e) => handleProductFormChange('specialPrice', e.target.value)}
                                                                placeholder="0.00"
                                                                step="0.01"
                                                            />
                                                        </div>
                                        </div>
                                    </div>

                                                {/* Special Price Date Range */}
                                                <div className="col-md-6">
                                        <div className="form-group">
                                                        <label className="form-label">
                                                            <i className="fas fa-calendar text-info me-2"></i>
                                                            Special Price From Date
                                                        </label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={productForm.specialPriceFromDate}
                                                            onChange={(e) => handleProductFormChange('specialPriceFromDate', e.target.value)}
                                                        />
                                        </div>
                                    </div>
                                                <div className="col-md-6">
                                        <div className="form-group">
                                                        <label className="form-label">
                                                            <i className="fas fa-calendar text-info me-2"></i>
                                                            Special Price To Date
                                                        </label>
                                                        <input
                                                            type="date"
                                                className="form-control"
                                                            value={productForm.specialPriceToDate}
                                                            onChange={(e) => handleProductFormChange('specialPriceToDate', e.target.value)}
                                                        />
                                                    </div>
                                        </div>
                                    </div>

                                            {/* Inventory Section */}
                                            <div className="section-header mt-4">
                                                <h6 className="section-title">
                                                    <i className="fas fa-boxes text-primary me-2"></i>
                                                    Inventory Management
                                                </h6>
                                                <p className="section-description">
                                                    Manage stock levels and inventory settings
                                                </p>
                                            </div>
                                            <div className="row g-4">
                                                {/* Stock Quantity */}
                                    <div className="col-md-4">
                                        <div className="form-group">
                                                        <label className="form-label required">
                                                            <i className="fas fa-cubes text-primary me-2"></i>
                                                            Stock Quantity
                                                        </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={productForm.quantity}
                                                onChange={(e) => handleProductFormChange('quantity', e.target.value)}
                                                placeholder="0"
                                                            min="0"
                                            />
                                        </div>
                                    </div>

                                                {/* Minimum Quantity */}
                                    <div className="col-md-4">
                                        <div className="form-group">
                                                        <label className="form-label">
                                                            <i className="fas fa-exclamation-triangle text-warning me-2"></i>
                                                            Minimum Quantity Alert
                                                        </label>
                                            <input
                                                            type="number"
                                                className="form-control"
                                                            value={productForm.minQuantity}
                                                            onChange={(e) => handleProductFormChange('minQuantity', e.target.value)}
                                                            placeholder="0"
                                                            min="0"
                                                        />
                                                        <small className="form-text text-muted">
                                                            Alert when stock falls below this level
                                                        </small>
                                        </div>
                                    </div>



                                                {/* Unit */}
                                    <div className="col-md-4">
                                        <div className="form-group">
                                                        <label className="form-label">
                                                            <i className="fas fa-ruler text-info me-2"></i>
                                                            Unit
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={productForm.unit}
                                                            onChange={(e) => handleProductFormChange('unit', e.target.value)}
                                                            placeholder="e.g., 300GRM, 500ML, 1KG"
                                                        />
                                                        <small className="form-text text-muted">
                                                            Custom unit for sales (e.g., 300GRM, 500ML, 1KG)
                                                        </small>
                                        </div>
                                    </div>

                                                {/* Inventory Options */}
                                    <div className="col-12">
                                                    <div className="inventory-options">
                                                        <div className="row g-3">
                                                            <div className="col-md-6">
                                                                <div className="form-check form-switch">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="trackQuantity"
                                                                        checked={productForm.trackQuantity}
                                                                        onChange={(e) => handleProductFormChange('trackQuantity', e.target.checked)}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="trackQuantity">
                                                                        <i className="fas fa-chart-line text-primary me-2"></i>
                                                                        Track Quantity
                                                                    </label>
                                                                    <small className="form-text text-muted d-block">
                                                                        Enable inventory tracking for this product
                                                                    </small>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-check form-switch">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="allowBackorder"
                                                                        checked={productForm.allowBackorder}
                                                                        onChange={(e) => handleProductFormChange('allowBackorder', e.target.checked)}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="allowBackorder">
                                                                        <i className="fas fa-undo text-info me-2"></i>
                                                                        Allow Backorders
                                                                    </label>
                                                                    <small className="form-text text-muted d-block">
                                                                        Allow orders when out of stock
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                    {/* Images Tab */}
                                    <div className={`tab-pane fade ${activeTab === 'images' ? 'show active' : ''}`} id="images" role="tabpanel">
                                        <div className="tab-pane-content">
                                            <div className="section-header">
                                                <h6 className="section-title">
                                                    <i className="fas fa-images text-primary me-2"></i>
                                                    Product Images
                                                </h6>
                                                <p className="section-description">
                                                    Upload and manage product images with drag & drop functionality
                                                </p>
                                            </div>
                                            
                                            {/* Drag and Drop Upload Area */}
                                            <div 
                                                className="image-upload-container"
                                                onDrop={handleDrop}
                                                onDragOver={handleDragOver}
                                                onDragEnter={handleDragEnter}
                                            >
                                                <div className="upload-area">
                                                    <div className="upload-content">
                                                        <div className="upload-icon">
                                                            <i className="fas fa-cloud-upload-alt fa-3x text-primary mb-3"></i>
                                                        </div>
                                                        <h5 className="text-dark mb-2">Drag & Drop Images Here</h5>
                                                        <p className="text-muted mb-3">or</p>
                                                        <label htmlFor="image-upload" className="btn btn-primary btn-lg">
                                                            <i className="fas fa-plus me-2"></i>
                                                            Choose Images
                                                        </label>
                                            <input
                                                            id="image-upload"
                                                type="file"
                                                            className="d-none"
                                                multiple
                                                accept="image/*"
                                                onChange={handleImageChange}
                                            />
                                                        <div className="mt-3">
                                                            <small className="text-muted">
                                                                Supports: JPG, PNG, GIF, WebP (Max 5MB each)
                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {/* Display uploaded images */}
                                            {productForm.images && productForm.images.length > 0 && (
                                                <div className="uploaded-images-container mt-4">
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <h6 className="mb-0">
                                                            <i className="fas fa-images text-primary me-2"></i>
                                                            Uploaded Images ({productForm.images.length})
                                                        </h6>
                                                        <small className="text-muted">
                                                            Drag images to reorder • First image is primary
                                                        </small>
                                                    </div>
                                                    
                                                    <div className="images-grid">
                                                        {productForm.images.map((image, index) => (
                                                            <div 
                                                                key={index} 
                                                                className="image-item"
                                                                draggable
                                                                onDragStart={(e) => {
                                                                    e.dataTransfer.setData('text/plain', index.toString())
                                                                }}
                                                                onDragOver={(e) => e.preventDefault()}
                                                                onDrop={(e) => {
                                                                    e.preventDefault()
                                                                    const dragIndex = parseInt(e.dataTransfer.getData('text/plain'))
                                                                    if (dragIndex !== index) {
                                                                        moveImage(dragIndex, index)
                                                                    }
                                                                }}
                                                            >
                                                                <div className="image-preview">
                                                                    <img
                                                                        src={image.url || URL.createObjectURL(image)}
                                                                        alt={`Preview ${index + 1}`}
                                                                        className="preview-img"
                                                                    />
                                                                    
                                                                    {/* Image Overlay */}
                                                                    <div className="image-overlay">
                                                                        <div className="image-actions">
                                                                            {index !== 0 && (
                                                                    <button
                                                                        type="button"
                                                                                    className="btn btn-sm btn-success mb-1"
                                                                                    onClick={() => setPrimaryImage(index)}
                                                                                    title="Set as Primary"
                                                                                >
                                                                                    <i className="fas fa-star"></i>
                                                                                </button>
                                                                            )}
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-danger"
                                                                        onClick={() => removeImage(index)}
                                                                                title="Remove Image"
                                                                    >
                                                                                <i className="fas fa-trash"></i>
                                                                    </button>
                                                                        </div>
                                                                    </div>
                                                                    
                                                                    {/* Image Labels */}
                                                                    <div className="image-labels">
                                                                    {index === 0 && (
                                                                            <span className="badge bg-primary">
                                                                                <i className="fas fa-star me-1"></i>
                                                                            Primary
                                                                        </span>
                                                                    )}
                                                                        <span className="badge bg-secondary ms-1">
                                                                            {index + 1}
                                                                        </span>
                                                                    </div>
                                                                    
                                                                    {/* Drag Handle */}
                                                                    <div className="drag-handle">
                                                                        <i className="fas fa-grip-vertical"></i>
                                                                    </div>
                                                                </div>
                                                                
                                                                {/* Image Info */}
                                                                <div className="image-info">
                                                                    <div className="image-name" title={image.name}>
                                                                        {image.name.length > 20 ? 
                                                                            image.name.substring(0, 20) + '...' : 
                                                                            image.name
                                                                        }
                                                                    </div>
                                                                    <div className="image-size text-muted">
                                                                        {image.size ? (image.size / 1024).toFixed(1) + ' KB' : 'Image'}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Variations Tab */}
                                    <div className={`tab-pane fade ${activeTab === 'variations' ? 'show active' : ''}`} id="variations" role="tabpanel">
                                        <div className="tab-pane-content">
                                            {productForm.hasOptions === 0 ? (
                                                <div className="text-center py-5">
                                                    <i className="fas fa-cubes fa-3x text-muted mb-3"></i>
                                                    <h5 className="text-muted">Variations Not Enabled</h5>
                                                    <p className="text-muted">Enable "Configurable Product" in Basic Information tab to manage variations.</p>
                                </div>
                                            ) : (
                                                <>
                                                    {/* Variation Attributes Section */}
                                                    <div className="section-header">
                                                        <h6 className="section-title">
                                                            <i className="fas fa-tags text-primary me-2"></i>
                                                            Variation Attributes
                                                        </h6>
                                                        <p className="section-description">
                                                            Define attributes like Size, Color, etc. to create product variations
                                                        </p>
                            </div>

                                                    {/* Add Attribute Button */}
                                                    <div className="mb-4">
                                <button
                                    type="button"
                                                            className="btn btn-outline-primary"
                                                            onClick={addVariationAttribute}
                                                        >
                                                            <i className="fas fa-plus me-2"></i>
                                                            Add Attribute
                                                        </button>
                                                    </div>

                                                    {/* Attributes List */}
                                                    {variationAttributes.map((attribute, attrIndex) => (
                                                        <div key={attribute.id} className="variation-attribute-card mb-4">
                                                            <div className="attribute-header">
                                                                <div className="row g-3 align-items-center">
                                                                    <div className="col-md-4">
                                                                        <div className="form-group">
                                                                            <label className="form-label">
                                                                                <i className="fas fa-tag text-muted me-2"></i>
                                                                                Attribute Name
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                value={attribute.name}
                                                                                onChange={(e) => updateVariationAttribute(attrIndex, 'name', e.target.value)}
                                                                                placeholder="e.g., Size, Color, Material"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <div className="d-flex align-items-end h-100">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-outline-success me-2"
                                                                                onClick={() => addVariationOption(attrIndex)}
                                                                            >
                                                                                <i className="fas fa-plus me-1"></i>
                                                                                Add Option
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-outline-danger"
                                                                                onClick={() => removeVariationAttribute(attrIndex)}
                                                                            >
                                                                                <i className="fas fa-trash me-1"></i>
                                                                                Remove
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Options List */}
                                                            {attribute.options.length > 0 && (
                                                                <div className="attribute-options mt-3">
                                                                    <h6 className="options-title">Options:</h6>
                                                                    <div className="row g-2">
                                                                        {attribute.options.map((option, optIndex) => (
                                                                            <div key={option.id} className="col-md-4">
                                                                                <div className="option-card">
                                                                                    <div className="row g-2">
                                                                                        <div className="col-6">
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control form-control-sm"
                                                                                                value={option.value}
                                                                                                onChange={(e) => updateVariationOption(attrIndex, optIndex, 'value', e.target.value)}
                                                                                                placeholder="Option value"
                                                                                            />
                                                                                        </div>
                                                                                        <div className="col-4">
                                                                                            <input
                                                                                                type="number"
                                                                                                className="form-control form-control-sm"
                                                                                                value={option.price}
                                                                                                onChange={(e) => updateVariationOption(attrIndex, optIndex, 'price', e.target.value)}
                                                                                                placeholder="Price"
                                                                                                step="0.01"
                                                                                            />
                                                                                        </div>
                                                                                        <div className="col-2">
                                                                                            <button
                                                                                                type="button"
                                                                                                className="btn btn-sm btn-outline-danger"
                                                                                                onClick={() => removeVariationOption(attrIndex, optIndex)}
                                                                                                title="Remove Option"
                                                                                            >
                                                                                                <i className="fas fa-times"></i>
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    ))}

                                                    {/* Generate Variations Button */}
                                                    {variationAttributes.length > 0 && (
                                                        <div className="text-center mt-4">
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary btn-lg"
                                                                onClick={generateVariations}
                                                            >
                                                                <i className="fas fa-magic me-2"></i>
                                                                Generate Variations
                                                            </button>
                                                            <p className="text-muted mt-2">
                                                                This will create all possible combinations of your attributes
                                                            </p>
                                                        </div>
                                                    )}

                                                    {/* Generated Variations Section */}
                                                    {productForm.variations.length > 0 && (
                                                        <>
                                                            <div className="section-header mt-5">
                                                                <h6 className="section-title">
                                                                    <i className="fas fa-cubes text-primary me-2"></i>
                                                                    Product Variations ({productForm.variations.length})
                                                                </h6>
                                                                <p className="section-description">
                                                                    Manage individual variation properties
                                                                </p>
                                                            </div>

                                                            <div className="variations-grid">
                                                                {productForm.variations.map((variation, index) => (
                                                                    <div key={variation.id} className="variation-card">
                                                                        <div className="variation-header">
                                                                            <h6 className="variation-title">
                                                                                Variation #{index + 1}
                                                                            </h6>
                                                                            <div className="variation-attributes">
                                                                                {Object.entries(variation.attributes).map(([key, value]) => (
                                                                                    <span key={key} className="badge badge-light-primary me-1">
                                                                                        {key}: {value.value}
                                                                                    </span>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                        
                                                                        <div className="variation-content">
                                                                            <div className="row g-3">
                                                                                <div className="col-md-6">
                                                                                    <div className="form-group">
                                                                                        <label className="form-label">SKU</label>
                                                                                        <input
                                                                                            type="text"
                                                                                            className="form-control form-control-sm"
                                                                                            value={variation.sku}
                                                                                            onChange={(e) => updateVariation(index, 'sku', e.target.value)}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <div className="form-group">
                                                                                        <label className="form-label">Price</label>
                                                                                        <input
                                                                                            type="number"
                                                                                            className="form-control form-control-sm"
                                                                                            value={variation.price}
                                                                                            onChange={(e) => updateVariation(index, 'price', e.target.value)}
                                                                                            step="0.01"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <div className="form-group">
                                                                                        <label className="form-label">Cost Price</label>
                                                                                        <input
                                                                                            type="number"
                                                                                            className="form-control form-control-sm"
                                                                                            value={variation.costPrice}
                                                                                            onChange={(e) => updateVariation(index, 'costPrice', e.target.value)}
                                                                                            step="0.01"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <div className="form-group">
                                                                                        <label className="form-label">Quantity</label>
                                                                                        <input
                                                                                            type="number"
                                                                                            className="form-control form-control-sm"
                                                                                            value={variation.quantity}
                                                                                            onChange={(e) => updateVariation(index, 'quantity', e.target.value)}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <div className="form-group">
                                                                                        <label className="form-label">Weight</label>
                                                                                        <input
                                                                                            type="number"
                                                                                            className="form-control form-control-sm"
                                                                                            value={variation.weight}
                                                                                            onChange={(e) => updateVariation(index, 'weight', e.target.value)}
                                                                                            step="0.01"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>

                                    {/* SEO & Marketing Tab */}
                                    <div className={`tab-pane fade ${activeTab === 'seo' ? 'show active' : ''}`} id="seo" role="tabpanel">
                                        <div className="tab-pane-content">
                                            <div className="section-header">
                                                <h6 className="section-title">
                                                    <i className="fas fa-search text-primary me-2"></i>
                                                    SEO Optimization
                                                </h6>
                                                <p className="section-description">
                                                    Optimize your product for search engines
                                                </p>
                                </div>
                                            <div className="row g-4">
                                                {/* Meta Title */}
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <label className="form-label">
                                                            <i className="fas fa-heading text-muted me-2"></i>
                                                            Meta Title
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={productForm.metaTitle}
                                                            onChange={(e) => handleProductFormChange('metaTitle', e.target.value)}
                                                            placeholder="SEO-friendly page title"
                                                            maxLength="60"
                                                        />
                                                        <small className="form-text text-muted">
                                                            {productForm.metaTitle.length}/60 characters (optimal: 50-60)
                                                        </small>
                            </div>
                                                </div>

                                                {/* Meta Keywords */}
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">
                                                            <i className="fas fa-key text-muted me-2"></i>
                                                            Meta Keywords
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={productForm.metaKewords}
                                                            onChange={(e) => handleProductFormChange('metaKewords', e.target.value)}
                                                            placeholder="keyword1, keyword2, keyword3"
                                                        />
                                                        <small className="form-text text-muted">
                                                            Separate keywords with commas
                                                        </small>
                                                    </div>
                                                </div>

                                                {/* Tags */}
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">
                                                            <i className="fas fa-hashtag text-muted me-2"></i>
                                                            Product Tags
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={productForm.tags}
                                                            onChange={(e) => handleProductFormChange('tags', e.target.value)}
                                                            placeholder="tag1, tag2, tag3"
                                                        />
                                                        <small className="form-text text-muted">
                                                            Used for internal organization and filtering
                                                        </small>
                                                    </div>
                                                </div>

                                                {/* Meta Description */}
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <label className="form-label">
                                                            <i className="fas fa-align-left text-muted me-2"></i>
                                                            Meta Description
                                                        </label>
                                                        <textarea
                                                            className="form-control"
                                                            rows="3"
                                                            value={productForm.metaContent}
                                                            onChange={(e) => handleProductFormChange('metaContent', e.target.value)}
                                                            placeholder="Brief description that appears in search results"
                                                            maxLength="160"
                                                        ></textarea>
                                                        <small className="form-text text-muted">
                                                            {productForm.metaContent.length}/160 characters (optimal: 140-160)
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer sticky-bottom bg-white border-top p-4">
                                <div className="d-flex justify-content-between align-items-center w-100">
                                    <div className="form-progress">
                                        <small className="text-muted">
                                            <i className="fas fa-info-circle me-1"></i>
                                            Fill required fields to save the product
                                        </small>
                                    </div>
                                    <div className="form-actions">
                                <button
                                    type="button"
                                            className="btn btn-light me-3"
                                    onClick={() => {
                                        setShowModal(false)
                                        setShowEditModal(false)
                                    }}
                                >
                                            <i className="fas fa-times me-2"></i>
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                            className="btn btn-primary btn-lg"
                                    onClick={submitProduct}
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                            {isEditing ? 'Updating...' : 'Creating...'}
                                        </>
                                    ) : (
                                                <>
                                                    <i className={`fas ${isEditing ? 'fa-save' : 'fa-plus'} me-2`}></i>
                                                    {isEditing ? 'Update Product' : 'Create Product'}
                                                </>
                                    )}
                                </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Product Details Modal */}
            {showDetailsModal && productDetails && (
                <div className="modal fade show d-block modal-adaptive" 
                     style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                    <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header sticky-top bg-white">
                                <div className="modal-title-wrapper">
                                    <h5 className="modal-title mb-1">
                                        <i className="fas fa-box text-primary me-2"></i>
                                        Product Details
                                    </h5>
                                    <p className="text-muted mb-0">Complete information about {productDetails.product_name || productDetails.productName}</p>
                                </div>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowDetailsModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                {detailsLoading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mt-2">Loading product details...</p>
                                    </div>
                                ) : (
                                    <div className="row g-4">
                                        {/* Product Images Section */}
                                        {productDetails.productImage && productDetails.productImage.length > 0 && (
                                            <div className="col-12">
                                                <div className="product-images-section">
                                                    <h6 className="section-title">
                                                        <i className="fas fa-images text-primary me-2"></i>
                                                        Product Images ({productDetails.productImage.length})
                                                    </h6>
                                                    <div className="product-images-grid">
                                                        {productDetails.productImage.map((image, index) => (
                                                            <div key={index} className="product-image-item">
                                                                <img
                                                                    src={`${process.env.REACT_APP_IMAGE_STORAGE}uploads/products/${productDetails.product_id}/${image.thumb_file_name}`}
                                                                    alt={`${productDetails.product_name || productDetails.productName} - Image ${index + 1}`}
                                                                    className="product-detail-img"
                                                                    onError={(e) => {
                                                                        e.target.src = '/images/no-image.png';
                                                                        e.target.onerror = null;
                                                                    }}
                                                                />
                                                                <div className="image-overlay">
                                                                    <span className="image-number">{index + 1}</span>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Basic Information */}
                                        <div className="col-md-6">
                                            <div className="info-section">
                                                <h6 className="section-title">
                                                    <i className="fas fa-info-circle text-primary me-2"></i>
                                                    Basic Information
                                                </h6>
                                                <div className="info-table">
                                                    <div className="info-row">
                                                        <span className="info-label">Product Name:</span>
                                                        <span className="info-value">{productDetails.product_name || productDetails.productName}</span>
                                                    </div>
                                                    <div className="info-row">
                                                        <span className="info-label">SKU:</span>
                                                        <span className="info-value">
                                                            <span className="badge bg-light-primary">{productDetails.sku}</span>
                                                            </span>
                                                    </div>
                                                    <div className="info-row">
                                                        <span className="info-label">Slug:</span>
                                                        <span className="info-value">{productDetails.slug}</span>
                                                    </div>
                                                    <div className="info-row">
                                                        <span className="info-label">Type:</span>
                                                        <span className="info-value">
                                                            <span className={`badge ${productDetails.type_id === 'simple' ? 'bg-primary' : 'bg-info'}`}>
                                                                {productDetails.type_id === 'simple' ? 'Simple Product' : 'Configurable Product'}
                                                            </span>
                                                        </span>
                                                    </div>
                                                    <div className="info-row">
                                                        <span className="info-label">Status:</span>
                                                        <span className="info-value">
                                                            <span className={`badge ${getStatusBadge(productDetails.status)}`}>
                                                                {getStatusText(productDetails.status)}
                                                            </span>
                                                        </span>
                                        </div>
                                                    <div className="info-row">
                                                        <span className="info-label">Vendor:</span>
                                                        <span className="info-value">{productDetails.vendorName || 'N/A'}</span>
                                                    </div>
                                                    <div className="info-row">
                                                        <span className="info-label">Created:</span>
                                                        <span className="info-value">{formatDate(productDetails.created_at)}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Pricing & Stock */}
                                        <div className="col-md-6">
                                            <div className="info-section">
                                                <h6 className="section-title">
                                                    <i className="fas fa-dollar-sign text-primary me-2"></i>
                                                    Pricing & Stock
                                                </h6>
                                                <div className="info-table">
                                                    <div className="info-row">
                                                        <span className="info-label">Price:</span>
                                                        <span className="info-value">
                                                            <span className="text-success fw-bold fs-5">
                                                            {formatPrice(productDetails.price)}
                                                            </span>
                                                        </span>
                                                    </div>
                                                    <div className="info-row">
                                                        <span className="info-label">Cost Price:</span>
                                                        <span className="info-value">{formatPrice(productDetails.costPrice)}</span>
                                                    </div>
                                                    {((productDetails.specialPrice && productDetails.specialPrice > 0) || 
                                                      (productDetails.product_special_price && productDetails.product_special_price.length > 0)) && (
                                                        <>
                                                            <div className="info-row">
                                                                <span className="info-label">Special Price:</span>
                                                                <span className="info-value">
                                                                    <span className="text-danger fw-bold fs-5">
                                                                        {formatPrice(productDetails.specialPrice || 
                                                                          (productDetails.product_special_price && productDetails.product_special_price[0] ? productDetails.product_special_price[0].price : 0))}
                                                                    </span>
                                                                </span>
                                                            </div>
                                                            {(productDetails.specialPriceFromDate || productDetails.specialPriceToDate || 
                                                              (productDetails.product_special_price && productDetails.product_special_price[0])) && (
                                                                <div className="info-row">
                                                                    <span className="info-label">Special Price Period:</span>
                                                                    <span className="info-value">
                                                                        {productDetails.specialPriceFromDate ? formatDate(productDetails.specialPriceFromDate) : 
                                         (productDetails.product_special_price && productDetails.product_special_price[0] ? formatDate(productDetails.product_special_price[0].priceFrom) : 'No start date')} - 
                                                                        {productDetails.specialPriceToDate ? formatDate(productDetails.specialPriceToDate) : 
                                         (productDetails.product_special_price && productDetails.product_special_price[0] ? formatDate(productDetails.product_special_price[0].priceTo) : 'No end date')}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                    <div className="info-row">
                                                        <span className="info-label">Stock Quantity:</span>
                                                        <span className="info-value">
                                                            <span className={`badge ${(productDetails.quantity || productDetails.qty || 0) > 0 ? 'bg-success' : 'bg-danger'}`}>
                                                                {productDetails.quantity || productDetails.qty || 0}
                                                            </span>
                                                        </span>
                                                    </div>
                                                    <div className="info-row">
                                                        <span className="info-label">Unit:</span>
                                                        <span className="info-value">
                                                            <span className="badge bg-light-info">
                                                                {productDetails.unit || 'N/A'}
                                                            </span>
                                                        </span>
                                                    </div>
                                                    <div className="info-row">
                                                        <span className="info-label">Has Options:</span>
                                                        <span className="info-value">
                                                            <span className={`badge ${(productDetails.has_options || productDetails.hasOptions) ? 'bg-warning' : 'bg-secondary'}`}>
                                                                {(productDetails.has_options || productDetails.hasOptions) ? 'Yes' : 'No'}
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Categories */}
                                        {productDetails.categories && productDetails.categories.length > 0 && (
                                            <div className="col-12">
                                                <div className="info-section">
                                                    <h6 className="section-title">
                                                        <i className="fas fa-sitemap text-primary me-2"></i>
                                                        Categories
                                                    </h6>
                                                    <div className="categories-display">
                                                        {productDetails.categories.map((cat, index) => (
                                                            <span key={index} className="badge bg-primary me-2 mb-2">
                                                                    {cat}
                                                                </span>
                                                            ))}
                                        </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Description */}
                                        {productDetails.description && (
                                            <div className="col-12">
                                                <div className="info-section">
                                                    <h6 className="section-title">
                                                        <i className="fas fa-file-alt text-primary me-2"></i>
                                                        Description
                                                    </h6>
                                                    <div className="description-content">
                                                        <div dangerouslySetInnerHTML={{ __html: productDetails.description }} />
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* SEO Information */}
                                        {(productDetails.meta_title || productDetails.meta_content || productDetails.meta_kewords || productDetails.metaTitle || productDetails.metaContent || productDetails.metaKewords) && (
                                            <div className="col-12">
                                                <div className="info-section">
                                                    <h6 className="section-title">
                                                        <i className="fas fa-search text-primary me-2"></i>
                                                        SEO Information
                                                    </h6>
                                                    <div className="info-table">
                                                        {(productDetails.meta_title || productDetails.metaTitle) && (
                                                            <div className="info-row">
                                                                <span className="info-label">Meta Title:</span>
                                                                <span className="info-value">{productDetails.meta_title || productDetails.metaTitle}</span>
                                                            </div>
                                                        )}
                                                        {(productDetails.meta_kewords || productDetails.metaKewords) && (
                                                            <div className="info-row">
                                                                <span className="info-label">Meta Keywords:</span>
                                                                <span className="info-value">{productDetails.meta_kewords || productDetails.metaKewords}</span>
                                                            </div>
                                                        )}
                                                        {(productDetails.meta_content || productDetails.metaContent) && (
                                                            <div className="info-row">
                                                                <span className="info-label">Meta Description:</span>
                                                                <span className="info-value">{productDetails.meta_content || productDetails.metaContent}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer sticky-bottom bg-white">
                                <div className="d-flex justify-content-between align-items-center w-100">
                                    <div className="product-actions">
                                <button
                                    type="button"
                                            className="btn btn-outline-secondary me-2"
                                            onClick={() => toggleProductStatus(productDetails)}
                                            title={`Change status from ${getStatusText(productDetails.status)}`}
                                        >
                                            <i className={`fas fa-${productDetails.status === '1' ? 'times' : productDetails.status === '0' ? 'check' : 'exclamation-triangle'} me-1`}></i>
                                            {productDetails.status === '1' ? 'Deactivate' : productDetails.status === '0' ? 'Activate' : 'Fix Stock'}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger"
                                            onClick={() => {
                                                setShowDetailsModal(false)
                                                deleteProduct(productDetails)
                                            }}
                                        >
                                            <i className="fas fa-trash me-1"></i>
                                            Delete
                                        </button>
                                    </div>
                                    <div className="modal-actions">
                                        <button
                                            type="button"
                                            className="btn btn-secondary me-2"
                                    onClick={() => setShowDetailsModal(false)}
                                >
                                            <i className="fas fa-times me-1"></i>
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        setShowDetailsModal(false)
                                        openEditProductModal(productDetails)
                                    }}
                                >
                                            <i className="fas fa-edit me-1"></i>
                                    Edit Product
                                </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
                /* Mobile Product List Styling */
                .mobile-products-container {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                    padding: 0.5rem 0;
                }

                .mobile-product-card {
                    background: white;
                    border: 1px solid #e9ecef;
                    border-radius: 0.75rem;
                    padding: 1rem;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
                    transition: all 0.3s ease;
                    position: relative;
                }

                .mobile-product-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
                    border-color: #009ef7;
                }

                .product-card-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    margin-bottom: 0.75rem;
                    padding-bottom: 0.75rem;
                    border-bottom: 1px solid #f1f3f4;
                }

                .product-title-section {
                    flex: 1;
                    min-width: 0; /* Allow text truncation */
                }

                .product-name {
                    color: #181c32;
                    font-weight: 600;
                    font-size: 1rem;
                    line-height: 1.3;
                    margin: 0;
                    word-break: break-word;
                }

                .product-meta {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 0.5rem;
                    margin-top: 0.5rem;
                }

                .sku-badge {
                    background: #e1f0ff;
                    color: #009ef7;
                    padding: 0.25rem 0.5rem;
                    border-radius: 0.375rem;
                    font-size: 0.75rem;
                    font-weight: 600;
                    border: 1px solid #b3d9ff;
                }

                .status-badge {
                    padding: 0.25rem 0.5rem;
                    border-radius: 0.375rem;
                    font-size: 0.75rem;
                    font-weight: 600;
                    color: white;
                }

                .product-price {
                    text-align: right;
                    margin-left: 1rem;
                }

                .price-text {
                    font-size: 1.125rem;
                    font-weight: 700;
                    color: #50cd89;
                    line-height: 1.2;
                }

                .product-card-body {
                    margin-bottom: 1rem;
                }

                .product-stats {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 0.5rem;
                    margin-bottom: 0.75rem;
                }

                .stat-item {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    padding: 0.375rem 0;
                }

                .stat-item i {
                    width: 16px;
                    text-align: center;
                    font-size: 0.875rem;
                }

                .stat-label {
                    font-size: 0.875rem;
                    color: #5e6278;
                    font-weight: 500;
                    min-width: 60px;
                }

                .stat-value {
                    font-size: 0.875rem;
                    font-weight: 600;
                    color: #181c32;
                }

                .product-attributes {
                    margin-top: 0.5rem;
                    padding-top: 0.5rem;
                    border-top: 1px solid #f1f3f4;
                }

                .product-card-actions {
                    display: flex;
                    gap: 0.5rem;
                    flex-wrap: wrap;
                }

                .product-card-actions .btn {
                    font-size: 0.8rem;
                    padding: 0.5rem 0.75rem;
                    border-radius: 0.5rem;
                    font-weight: 500;
                    transition: all 0.3s ease;
                    min-height: 38px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .product-card-actions .btn:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
                }

                .product-card-actions .btn i {
                    font-size: 0.75rem;
                }

                /* Enhanced Mobile Pagination */
                .pagination-container {
                    background: #f8f9fa;
                    border-radius: 0.75rem;
                    padding: 1rem;
                    border: 1px solid #e9ecef;
                }

                .pagination-info {
                    font-size: 0.875rem;
                }

                .pagination-mobile {
                    margin: 0;
                    justify-content: center;
                    align-items: center;
                    gap: 0.25rem;
                }

                .pagination-mobile .page-item {
                    margin: 0;
                }

                .pagination-mobile .page-link {
                    border: 1px solid #e1e5e9;
                    color: #5e6278;
                    background: white;
                    padding: 0.5rem 0.75rem;
                    border-radius: 0.5rem;
                    font-weight: 500;
                    transition: all 0.3s ease;
                    min-width: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .pagination-mobile .page-link:hover {
                    background: #009ef7;
                    border-color: #009ef7;
                    color: white;
                    transform: translateY(-1px);
                    box-shadow: 0 2px 8px rgba(0, 158, 247, 0.3);
                }

                .pagination-mobile .page-item.active .page-link {
                    background: #009ef7;
                    border-color: #009ef7;
                    color: white;
                    font-weight: 600;
                    box-shadow: 0 2px 8px rgba(0, 158, 247, 0.3);
                }

                .pagination-mobile .page-item.disabled .page-link {
                    opacity: 0.5;
                    cursor: not-allowed;
                    background: #f8f9fa;
                    color: #a1a5b7;
                }

                .pagination-mobile .page-item.disabled .page-link:hover {
                    background: #f8f9fa;
                    color: #a1a5b7;
                    transform: none;
                    box-shadow: none;
                }

                /* Mobile Header Button */
                .btn-mobile-full {
                    min-width: 140px;
                    font-weight: 600;
                    letter-spacing: 0.025em;
                    border-radius: 0.5rem;
                    box-shadow: 0 2px 6px rgba(0, 158, 247, 0.25);
                    transition: all 0.3s ease;
                }

                .btn-mobile-full:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(0, 158, 247, 0.35);
                }

                /* Enhanced Search and Filter Section */
                @media (max-width: 768px) {
                    .card-header {
                        padding: 1rem;
                    }

                    .card-header .card-title h3 {
                        font-size: 1.25rem;
                        margin-bottom: 0.25rem;
                    }

                    .card-toolbar {
                        width: 100%;
                    }

                    .btn-mobile-full {
                        width: 100%;
                        justify-content: center;
                        padding: 0.875rem 1.5rem;
                        font-size: 0.95rem;
                        min-height: 48px;
                        border-radius: 0.75rem;
                    }

                    .card-body.border-bottom {
                        padding: 1rem;
                    }

                    .form-control-lg, .form-select-lg {
                        padding: 0.75rem 1rem;
                        font-size: 0.9rem;
                        border-radius: 0.5rem;
                    }

                    .position-relative .position-absolute {
                        padding-left: 1rem;
                    }

                    /* Mobile Stats Grid Enhancement */
                    .product-stats {
                        grid-template-columns: 1fr 1fr;
                        gap: 0.75rem;
                        background: #f8f9fa;
                        padding: 0.75rem;
                        border-radius: 0.5rem;
                        border: 1px solid #f1f3f4;
                    }

                    .stat-item {
                        padding: 0.25rem 0;
                        flex-direction: column;
                        align-items: flex-start;
                        text-align: left;
                    }

                    .stat-item i {
                        margin-bottom: 0.25rem;
                        width: auto;
                    }

                    .stat-label {
                        font-size: 0.75rem;
                        margin-bottom: 0.125rem;
                        min-width: auto;
                    }

                    .stat-value {
                        font-size: 0.875rem;
                        font-weight: 700;
                    }

                    /* Mobile Actions Responsive */
                    .product-card-actions {
                        flex-direction: row;
                        flex-wrap: wrap;
                        gap: 0.5rem;
                    }

                    .product-card-actions .btn {
                        flex: 1;
                        min-width: 0;
                        padding: 0.5rem 0.75rem;
                        font-size: 0.8rem;
                        justify-content: center;
                    }

                    .product-card-actions .btn i {
                        margin-right: 0.5rem;
                    }

                    /* Mobile Pagination Responsive */
                    .pagination-container {
                        padding: 0.75rem;
                        text-align: center;
                    }

                    .pagination-mobile .page-link {
                        padding: 0.5rem;
                        min-width: 44px;
                        min-height: 44px;
                    }
                }

                @media (max-width: 576px) {
                    .mobile-product-card {
                        padding: 0.75rem;
                        border-radius: 0.5rem;
                    }

                    .product-card-header {
                        flex-direction: column;
                        align-items: stretch;
                        gap: 0.75rem;
                    }

                    .product-price {
                        text-align: left;
                        margin-left: 0;
                        padding-top: 0.5rem;
                        border-top: 1px solid #f1f3f4;
                    }

                    .price-text {
                        font-size: 1.25rem;
                    }

                    .product-meta {
                        gap: 0.375rem;
                    }

                    .sku-badge, .status-badge {
                        font-size: 0.7rem;
                        padding: 0.25rem 0.375rem;
                    }

                    .product-name {
                        font-size: 0.95rem;
                    }

                    .product-stats {
                        grid-template-columns: 1fr;
                        gap: 0.5rem;
                        padding: 0.5rem;
                    }

                    .stat-item {
                        flex-direction: row;
                        align-items: center;
                        padding: 0.375rem 0;
                    }

                    .stat-item i {
                        margin-bottom: 0;
                        margin-right: 0.5rem;
                        width: 16px;
                    }

                    .stat-label {
                        font-size: 0.8rem;
                        margin-bottom: 0;
                        margin-right: 0.5rem;
                        min-width: 50px;
                    }

                    .stat-value {
                        font-size: 0.8rem;
                    }

                    .pagination-mobile .page-link {
                        padding: 0.375rem;
                        min-width: 40px;
                        min-height: 40px;
                        font-size: 0.875rem;
                    }

                    .pagination-info {
                        font-size: 0.8rem;
                        margin-bottom: 0.75rem;
                    }
                }

                /* Extra small devices */
                @media (max-width: 480px) {
                    .card-header,
                    .card-body.border-bottom,
                    .card-body {
                        padding: 0.75rem;
                    }

                    .mobile-products-container {
                        gap: 0.75rem;
                        padding: 0.25rem 0;
                    }

                    .mobile-product-card {
                        padding: 0.625rem;
                    }

                    .product-name {
                        font-size: 0.9rem;
                        line-height: 1.25;
                    }

                    .product-card-actions .btn {
                        padding: 0.625rem 0.75rem;
                        font-size: 0.8rem;
                    }

                    .price-text {
                        font-size: 1.125rem;
                    }

                    .pagination-container {
                        padding: 0.5rem;
                    }

                    .pagination-mobile .page-link {
                        padding: 0.25rem;
                        min-width: 36px;
                        min-height: 36px;
                        font-size: 0.8rem;
                    }
                }

                /* Landscape Mobile Optimization */
                @media (max-width: 896px) and (orientation: landscape) {
                    .product-stats {
                        grid-template-columns: 1fr 1fr 1fr;
                    }

                    .product-card-actions {
                        flex-direction: row;
                        flex-wrap: wrap;
                    }

                    .product-card-actions .btn {
                        flex: 1;
                        min-width: calc(50% - 0.25rem);
                    }
                }

                /* Touch-friendly enhancements */
                @media (hover: none) and (pointer: coarse) {
                    .mobile-product-card {
                        border-width: 2px;
                    }

                    .product-card-actions .btn {
                        min-height: 48px;
                        font-size: 0.9rem;
                    }

                    .pagination-mobile .page-link {
                        min-width: 48px;
                        min-height: 48px;
                    }

                    .form-control-lg, .form-select-lg {
                        min-height: 48px;
                    }
                }

                /* High contrast and accessibility */
                @media (prefers-contrast: high) {
                    .mobile-product-card {
                        border-width: 2px;
                        border-color: #000;
                    }

                    .product-card-actions .btn {
                        border-width: 2px;
                    }

                    .sku-badge, .status-badge {
                        border-width: 2px;
                    }
                }

                /* Reduced motion */
                @media (prefers-reduced-motion: reduce) {
                    .mobile-product-card,
                    .product-card-actions .btn,
                    .pagination-mobile .page-link {
                        transition: none;
                    }

                    .mobile-product-card:hover,
                    .product-card-actions .btn:hover,
                    .pagination-mobile .page-link:hover {
                        transform: none;
                    }
                }

                /* Product Modal Styling */
                .product-modal .modal-dialog {
                    max-width: 1200px;
                }

                .modal-title-wrapper {
                    flex: 1;
                }

                .modal-title-wrapper h4 {
                    color: #181c32;
                    font-weight: 600;
                }

                .modal-title-wrapper p {
                    color: #a1a5b7;
                    font-size: 0.875rem;
                    margin: 0;
                }

                /* Product Tabs Styling */
                .product-tabs-container {
                    background: #f8f9fa;
                    border-bottom: 1px solid #e9ecef;
                    padding: 0 1.5rem;
                }

                .product-tabs {
                    border-bottom: none;
                    margin-bottom: 0;
                }

                .product-tabs .nav-link {
                    border: none;
                    background: transparent;
                    color: #a1a5b7;
                    font-weight: 500;
                    padding: 1rem 1.5rem;
                    border-radius: 0;
                    border-bottom: 2px solid transparent;
                    transition: all 0.3s ease;
                }

                .product-tabs .nav-link:hover {
                    color: #009ef7;
                    background: rgba(0, 158, 247, 0.1);
                    border-bottom-color: rgba(0, 158, 247, 0.3);
                }

                .product-tabs .nav-link.active {
                    color: #009ef7;
                    background: white;
                    border-bottom-color: #009ef7;
                    font-weight: 600;
                }

                .product-tabs .nav-link i {
                    opacity: 0.7;
                }

                .product-tabs .nav-link.active i {
                    opacity: 1;
                }

                /* Tab Content Styling */
                .product-tab-content {
                    background: white;
                }

                .tab-pane-content {
                    padding: 2rem;
                }

                .section-header {
                    margin-bottom: 1.5rem;
                    padding-bottom: 1rem;
                    border-bottom: 1px solid #f1f3f4;
                }

                .section-title {
                    color: #181c32;
                    font-weight: 600;
                    font-size: 1rem;
                    margin-bottom: 0.5rem;
                }

                .section-description {
                    color: #a1a5b7;
                    font-size: 0.875rem;
                    margin: 0;
                }

                /* Enhanced Form Controls */
                .form-group {
                    margin-bottom: 1.5rem;
                }

                .form-label {
                    color: #181c32;
                    font-weight: 500;
                    font-size: 0.875rem;
                    margin-bottom: 0.5rem;
                    display: flex;
                    align-items: center;
                }

                .form-label.required::after {
                    content: '*';
                    color: #f1416c;
                    margin-left: 0.25rem;
                }

                .form-control, .form-select {
                    border: 1px solid #e1e5e9;
                    border-radius: 0.475rem;
                    padding: 0.75rem 1rem;
                    font-size: 0.875rem;
                    transition: all 0.3s ease;
                    background-color: white;
                }

                .form-control:focus, .form-select:focus {
                    border-color: #009ef7;
                    box-shadow: 0 0 0 0.2rem rgba(0, 158, 247, 0.25);
                    background-color: white;
                }

                .form-control-lg {
                    padding: 1rem 1.25rem;
                    font-size: 1rem;
                    font-weight: 500;
                }

                .input-group-text {
                    background-color: #f8f9fa;
                    border: 1px solid #e1e5e9;
                    color: #7e8299;
                    font-weight: 500;
                }

                /* Form Switches */
                .form-check-input {
                    border: 2px solid #e1e5e9;
                    width: 2.5rem;
                    height: 1.25rem;
                }

                .form-check-input:checked {
                    background-color: #009ef7;
                    border-color: #009ef7;
                }

                .form-check-label {
                    color: #181c32;
                    font-weight: 500;
                    font-size: 0.875rem;
                    margin-left: 0.5rem;
                }

                /* Inventory Options Styling */
                .inventory-options {
                    background: #f8f9fa;
                    border-radius: 0.5rem;
                    padding: 1.5rem;
                    border: 1px solid #e9ecef;
                }

                /* Modal Footer Enhanced */
                .modal-footer {
                    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
                    border-top: 1px solid #e9ecef;
                }

                .form-progress {
                    display: flex;
                    align-items: center;
                }

                .form-actions {
                    display: flex;
                    align-items: center;
                }

                .btn-light {
                    background: white;
                    border: 1px solid #e1e5e9;
                    color: #7e8299;
                    font-weight: 500;
                    transition: all 0.3s ease;
                }

                .btn-light:hover {
                    background: #f8f9fa;
                    border-color: #d1d5db;
                    color: #181c32;
                }

                .btn-primary.btn-lg {
                    padding: 0.75rem 2rem;
                    font-size: 0.875rem;
                    font-weight: 600;
                    border-radius: 0.5rem;
                    box-shadow: 0 2px 6px rgba(0, 158, 247, 0.3);
                    transition: all 0.3s ease;
                }

                .btn-primary.btn-lg:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0, 158, 247, 0.4);
                }

                /* Rich Text Editor Styling */
                .rich-text-editor-container {
                    border: 1px solid #e1e5e9;
                    border-radius: 0.475rem;
                    overflow: hidden;
                    background: white;
                }

                .editor-toolbar {
                    background: #f8f9fa;
                    border-bottom: 1px solid #e1e5e9;
                    padding: 0.5rem;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 0.25rem;
                }

                .editor-toolbar .btn {
                    border: 1px solid #e1e5e9;
                    background: white;
                    color: #7e8299;
                    padding: 0.375rem 0.5rem;
                    font-size: 0.75rem;
                    transition: all 0.2s ease;
                }

                .editor-toolbar .btn:hover {
                    background: #009ef7;
                    border-color: #009ef7;
                    color: white;
                    transform: translateY(-1px);
                }

                .editor-toolbar .btn-group .btn {
                    border-radius: 0;
                }

                .editor-toolbar .btn-group .btn:first-child {
                    border-top-left-radius: 0.25rem;
                    border-bottom-left-radius: 0.25rem;
                }

                .editor-toolbar .btn-group .btn:last-child {
                    border-top-right-radius: 0.25rem;
                    border-bottom-right-radius: 0.25rem;
                }

                .rich-text-editor {
                    min-height: 200px;
                    max-height: 400px;
                    overflow-y: auto;
                    padding: 1rem;
                    border: none;
                    outline: none;
                    font-size: 0.875rem;
                    line-height: 1.6;
                    color: #181c32;
                    background: white;
                }

                .rich-text-editor:focus {
                    box-shadow: none;
                    border: none;
                }

                .rich-text-editor[contenteditable="true"]:empty:before {
                    content: attr(placeholder);
                    color: #a1a5b7;
                    font-style: italic;
                    pointer-events: none;
                }

                .rich-text-editor:focus {
                    outline: none;
                }

                .rich-text-editor ul, .rich-text-editor ol {
                    padding-left: 1.5rem;
                    margin: 0.5rem 0;
                }

                .rich-text-editor p {
                    margin: 0.5rem 0;
                }

                .rich-text-editor a {
                    color: #009ef7;
                    text-decoration: underline;
                }

                .rich-text-editor a:hover {
                    color: #0056b3;
                }

                .editor-footer {
                    background: #f8f9fa;
                    border-top: 1px solid #e1e5e9;
                    padding: 0.5rem 1rem;
                }

                .editor-footer small {
                    font-size: 0.75rem;
                    color: #a1a5b7;
                }

                /* Variations Styling */
                .variation-attribute-card {
                    background: #f8f9fa;
                    border: 1px solid #e9ecef;
                    border-radius: 0.5rem;
                    padding: 1.5rem;
                    transition: all 0.3s ease;
                }

                .variation-attribute-card:hover {
                    border-color: #009ef7;
                    box-shadow: 0 2px 8px rgba(0, 158, 247, 0.1);
                }

                .attribute-header {
                    border-bottom: 1px solid #e9ecef;
                    padding-bottom: 1rem;
                    margin-bottom: 1rem;
                }

                .options-title {
                    color: #181c32;
                    font-weight: 600;
                    font-size: 0.875rem;
                    margin-bottom: 0.75rem;
                }

                .option-card {
                    background: white;
                    border: 1px solid #e1e5e9;
                    border-radius: 0.375rem;
                    padding: 0.75rem;
                    transition: all 0.2s ease;
                }

                .option-card:hover {
                    border-color: #009ef7;
                    box-shadow: 0 1px 4px rgba(0, 158, 247, 0.1);
                }

                .variations-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
                    gap: 1.5rem;
                    margin-top: 1.5rem;
                }

                .variation-card {
                    background: white;
                    border: 1px solid #e9ecef;
                    border-radius: 0.5rem;
                    overflow: hidden;
                    transition: all 0.3s ease;
                }

                .variation-card:hover {
                    border-color: #009ef7;
                    box-shadow: 0 4px 12px rgba(0, 158, 247, 0.1);
                    transform: translateY(-2px);
                }

                .variation-header {
                    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
                    padding: 1rem;
                    border-bottom: 1px solid #e9ecef;
                }

                .variation-title {
                    color: #181c32;
                    font-weight: 600;
                    font-size: 1rem;
                    margin-bottom: 0.5rem;
                }

                .variation-attributes {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 0.25rem;
                }

                .variation-attributes .badge {
                    font-size: 0.75rem;
                    padding: 0.25rem 0.5rem;
                    background-color: #e1f0ff !important;
                    color: #009ef7;
                    border: 1px solid #b3d9ff;
                }

                .variation-content {
                    padding: 1rem;
                }

                .variation-content .form-group {
                    margin-bottom: 0.75rem;
                }

                .variation-content .form-label {
                    font-size: 0.8rem;
                    font-weight: 500;
                    color: #5e6278;
                    margin-bottom: 0.25rem;
                }

                .variation-content .form-control-sm {
                    padding: 0.375rem 0.5rem;
                    font-size: 0.8rem;
                }

                /* Disabled Tab Styling */
                .nav-link:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                    background: #f8f9fa;
                }

                .nav-link:disabled:hover {
                    background: #f8f9fa;
                    color: #a1a5b7;
                }

                /* Character Counters */
                .form-text.text-muted {
                    font-size: 0.75rem;
                    color: #a1a5b7;
                    margin-top: 0.25rem;
                }

                /* Mobile Responsive */
                @media (max-width: 768px) {
                    .product-modal .modal-dialog {
                        max-width: 100%;
                        margin: 0;
                        height: 100vh;
                    }

                    .product-modal .modal-content {
                        height: 100vh;
                        border-radius: 0;
                    }

                    .tab-pane-content {
                        padding: 1rem;
                    }

                    .product-tabs-container {
                        padding: 0 0.5rem;
                        overflow-x: auto;
                    }

                    .product-tabs {
                        flex-wrap: nowrap;
                        white-space: nowrap;
                    }

                    .product-tabs .nav-link {
                        padding: 0.75rem 1rem;
                        font-size: 0.8rem;
                        min-width: max-content;
                    }

                    .modal-footer {
                        padding: 1rem;
                        flex-direction: column;
                        gap: 1rem;
                    }

                    .form-actions {
                        width: 100%;
                        justify-content: stretch;
                        gap: 0.75rem;
                    }

                    .form-actions .btn {
                        flex: 1;
                    }
                }

                @media (max-width: 576px) {
                    .section-header {
                        padding-bottom: 0.75rem;
                        margin-bottom: 1rem;
                    }

                    .section-title {
                        font-size: 0.9rem;
                    }

                    .section-description {
                        font-size: 0.8rem;
                    }

                    .product-tabs .nav-link {
                        padding: 0.5rem 0.75rem;
                        font-size: 0.75rem;
                    }

                    .form-group {
                        margin-bottom: 1rem;
                    }

                    .form-label {
                        font-size: 0.8rem;
                    }

                    .form-control, .form-select {
                        padding: 0.5rem 0.75rem;
                        font-size: 0.8rem;
                    }
                }

                /* Image Upload Container Styling */
                .image-upload-container {
                    width: 100%;
                    margin-bottom: 1rem;
                }

                .upload-area {
                    border: 2px dashed #e1e5e9;
                    border-radius: 0.75rem;
                    padding: 3rem 2rem;
                    text-align: center;
                    background-color: #fafbfc;
                    transition: all 0.3s ease;
                    cursor: pointer;
                    position: relative;
                    min-height: 200px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .upload-area:hover {
                    border-color: #009ef7;
                    background-color: #f5f8ff;
                    transform: translateY(-2px);
                    box-shadow: 0 4px 20px rgba(0, 158, 247, 0.1);
                }

                .upload-content {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                }

                .upload-icon {
                    opacity: 0.6;
                    transition: all 0.3s ease;
                }

                .upload-area:hover .upload-icon {
                    opacity: 1;
                    transform: scale(1.1);
                }

                .btn-lg {
                    padding: 0.75rem 2rem;
                    font-size: 1rem;
                    border-radius: 0.5rem;
                    font-weight: 600;
                    transition: all 0.3s ease;
                }

                .btn-lg:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 15px rgba(0, 158, 247, 0.3);
                }

                /* Uploaded Images Grid */
                .uploaded-images-container {
                    background: #f8f9fa;
                    border-radius: 0.75rem;
                    padding: 1.5rem;
                    border: 1px solid #e9ecef;
                }

                .images-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
                    gap: 1rem;
                    margin-top: 1rem;
                }

                .image-item {
                    background: white;
                    border-radius: 0.5rem;
                    border: 1px solid #e9ecef;
                    overflow: hidden;
                    transition: all 0.3s ease;
                    cursor: move;
                    position: relative;
                }

                .image-item:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
                    border-color: #009ef7;
                }

                .image-item:active {
                    transform: scale(0.98);
                }

                .image-preview {
                    position: relative;
                    height: 150px;
                    overflow: hidden;
                }

                .preview-img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.3s ease;
                }

                .image-item:hover .preview-img {
                    transform: scale(1.05);
                }

                .image-overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.6);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    opacity: 0;
                    transition: opacity 0.3s ease;
                }

                .image-item:hover .image-overlay {
                    opacity: 1;
                }

                .image-actions {
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;
                }

                .image-actions .btn {
                    border: none;
                    font-weight: 600;
                    transition: all 0.3s ease;
                    min-width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .image-actions .btn:hover {
                    transform: scale(1.1);
                }

                .image-labels {
                    position: absolute;
                    bottom: 0.5rem;
                    left: 0.5rem;
                    display: flex;
                    gap: 0.25rem;
                }

                .image-labels .badge {
                    font-size: 0.7rem;
                    padding: 0.25rem 0.5rem;
                    border-radius: 0.25rem;
                    font-weight: 600;
                }

                .drag-handle {
                    position: absolute;
                    top: 0.5rem;
                    right: 0.5rem;
                    background: rgba(255, 255, 255, 0.9);
                    border-radius: 0.25rem;
                    padding: 0.25rem;
                    color: #6c757d;
                    font-size: 0.875rem;
                    cursor: grab;
                    transition: all 0.3s ease;
                    opacity: 0;
                }

                .image-item:hover .drag-handle {
                    opacity: 1;
                }

                .drag-handle:active {
                    cursor: grabbing;
                    background: rgba(255, 255, 255, 1);
                    color: #009ef7;
                }

                .image-info {
                    padding: 0.75rem;
                    border-top: 1px solid #f1f3f4;
                }

                .image-name {
                    font-size: 0.875rem;
                    font-weight: 600;
                    color: #181c32;
                    margin-bottom: 0.25rem;
                    line-height: 1.2;
                }

                .image-size {
                    font-size: 0.75rem;
                    color: #a1a5b7;
                }

                /* Categories Multi-Select Styling */
                .categories-multiselect {
                    width: 100%;
                }

                .categories-search input {
                    border: 1px solid #e1e5e9;
                    border-radius: 0.475rem;
                    padding: 0.5rem 0.75rem;
                    font-size: 0.875rem;
                }

                .categories-search input:focus {
                    border-color: #009ef7;
                    box-shadow: 0 0 0 0.2rem rgba(0, 158, 247, 0.25);
                    outline: none;
                }

                .categories-list {
                    background-color: #f9f9f9;
                    border: 1px solid #e1e5e9 !important;
                }

                .category-checkbox-container {
                    padding: 0.25rem 0;
                }

                .form-check {
                    margin-bottom: 0;
                }

                .form-check-input {
                    margin-top: 0.125rem;
                }

                .form-check-label {
                    font-size: 0.875rem;
                    color: #5e6278;
                    cursor: pointer;
                    margin-left: 0.25rem;
                }

                .form-check-input:checked {
                    background-color: #009ef7;
                    border-color: #009ef7;
                }

                .selected-categories .badge {
                    display: inline-flex;
                    align-items: center;
                    padding: 0.375rem 0.75rem;
                    font-size: 0.75rem;
                    background-color: #009ef7 !important;
                }

                .selected-categories .btn-close {
                    margin-left: 0.375rem;
                    padding: 0;
                    opacity: 0.8;
                    cursor: pointer;
                }

                .selected-categories .btn-close:hover {
                    opacity: 1;
                }

                /* Special Price Fields Styling */
                .form-group label.form-label {
                    color: #181c32;
                    font-weight: 500;
                    font-size: 0.875rem;
                    margin-bottom: 0.5rem;
                }

                .form-group input[type="date"] {
                    position: relative;
                }

                .form-group input[type="date"]::-webkit-calendar-picker-indicator {
                    cursor: pointer;
                    opacity: 0.6;
                }

                .form-group input[type="date"]::-webkit-calendar-picker-indicator:hover {
                    opacity: 1;
                }

                /* Mobile responsive adjustments */
                @media (max-width: 768px) {
                    /* Rich Text Editor Mobile */
                    .editor-toolbar {
                        padding: 0.375rem;
                        gap: 0.125rem;
                    }

                    .editor-toolbar .btn {
                        padding: 0.25rem 0.375rem;
                        font-size: 0.7rem;
                    }

                    .rich-text-editor {
                        min-height: 150px;
                        max-height: 300px;
                        padding: 0.75rem;
                        font-size: 0.8rem;
                    }

                    .editor-footer {
                        padding: 0.375rem 0.75rem;
                    }

                    .editor-footer small {
                        font-size: 0.7rem;
                    }

                    /* Image Upload Mobile */
                    .upload-area {
                        padding: 2rem 1rem;
                        min-height: 150px;
                    }

                    .upload-area h5 {
                        font-size: 1rem;
                    }

                    .btn-lg {
                        padding: 0.5rem 1.5rem;
                        font-size: 0.875rem;
                    }

                    .images-grid {
                        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
                        gap: 0.75rem;
                    }

                    .image-preview {
                        height: 120px;
                    }

                    .uploaded-images-container {
                        padding: 1rem;
                    }

                    .image-info {
                        padding: 0.5rem;
                    }

                    .image-name {
                        font-size: 0.8rem;
                    }

                    .image-size {
                        font-size: 0.7rem;
                    }

                    .image-actions .btn {
                        min-width: 35px;
                        height: 35px;
                        font-size: 0.8rem;
                    }

                    /* Categories Mobile */
                    .categories-list {
                        max-height: 150px !important;
                    }

                    .categories-search input {
                        font-size: 0.8rem;
                        padding: 0.375rem 0.5rem;
                    }

                    .form-check-label {
                        font-size: 0.8rem;
                    }

                    .selected-categories .badge {
                        font-size: 0.7rem;
                        padding: 0.25rem 0.5rem;
                        margin-bottom: 0.25rem;
                    }
                }

                @media (max-width: 576px) {
                    /* Rich Text Editor Extra Small */
                    .editor-toolbar {
                        padding: 0.25rem;
                        gap: 0.125rem;
                    }

                    .editor-toolbar .btn {
                        padding: 0.25rem 0.375rem;
                        font-size: 0.65rem;
                        min-width: 28px;
                    }

                    .rich-text-editor {
                        min-height: 120px;
                        max-height: 250px;
                        padding: 0.5rem;
                        font-size: 0.75rem;
                    }

                    .editor-footer {
                        padding: 0.25rem 0.5rem;
                    }

                    .editor-footer small {
                        font-size: 0.65rem;
                    }

                    /* Image Upload Extra Small */
                    .upload-area {
                        padding: 1.5rem 0.75rem;
                        min-height: 120px;
                    }

                    .upload-area h5 {
                        font-size: 0.9rem;
                    }

                    .upload-icon i {
                        font-size: 2rem !important;
                    }

                    .btn-lg {
                        padding: 0.5rem 1rem;
                        font-size: 0.8rem;
                    }

                    .images-grid {
                        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
                        gap: 0.5rem;
                    }

                    .image-preview {
                        height: 100px;
                    }

                    .uploaded-images-container {
                        padding: 0.75rem;
                    }

                    .uploaded-images-container h6 {
                        font-size: 0.9rem;
                    }

                    .image-labels .badge {
                        font-size: 0.6rem;
                        padding: 0.125rem 0.25rem;
                    }

                    .drag-handle {
                        font-size: 0.7rem;
                        padding: 0.125rem;
                    }

                    /* Categories Extra Small */
                    .categories-list {
                        max-height: 120px !important;
                        padding: 0.75rem !important;
                    }

                    .category-checkbox-container {
                        padding: 0.125rem 0;
                    }
                }

                /* Drag and Drop States */
                .upload-area.drag-over {
                    border-color: #009ef7;
                    background-color: #f0f8ff;
                    transform: scale(1.02);
                }

                .image-item.dragging {
                    opacity: 0.5;
                    transform: rotate(5deg);
                }

                .image-item.drag-over {
                    border-color: #009ef7;
                    box-shadow: 0 0 20px rgba(0, 158, 247, 0.3);
                }

                /* Loading states */
                .image-item.loading {
                    opacity: 0.7;
                }

                .image-item.loading::after {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    width: 20px;
                    height: 20px;
                    margin: -10px 0 0 -10px;
                    border: 2px solid #009ef7;
                    border-radius: 50%;
                    border-top-color: transparent;
                    animation: spin 1s linear infinite;
                }

                @keyframes spin {
                    to {
                        transform: rotate(360deg);
                    }
                }

                /* Variations Styling */
                .variation-attribute-card {
                    background: #f8f9fa;
                    border: 1px solid #e9ecef;
                    border-radius: 0.5rem;
                    padding: 1.5rem;
                    transition: all 0.3s ease;
                }

                .variation-attribute-card:hover {
                    border-color: #009ef7;
                    box-shadow: 0 2px 8px rgba(0, 158, 247, 0.1);
                }

                .attribute-header {
                    border-bottom: 1px solid #e9ecef;
                    padding-bottom: 1rem;
                    margin-bottom: 1rem;
                }

                .options-title {
                    color: #181c32;
                    font-weight: 600;
                    font-size: 0.875rem;
                    margin-bottom: 0.75rem;
                }

                .option-card {
                    background: white;
                    border: 1px solid #e1e5e9;
                    border-radius: 0.375rem;
                    padding: 0.75rem;
                    transition: all 0.2s ease;
                }

                .option-card:hover {
                    border-color: #009ef7;
                    box-shadow: 0 1px 4px rgba(0, 158, 247, 0.1);
                }

                .variations-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
                    gap: 1.5rem;
                    margin-top: 1.5rem;
                }

                .variation-card {
                    background: white;
                    border: 1px solid #e9ecef;
                    border-radius: 0.5rem;
                    overflow: hidden;
                    transition: all 0.3s ease;
                }

                .variation-card:hover {
                    border-color: #009ef7;
                    box-shadow: 0 4px 12px rgba(0, 158, 247, 0.1);
                    transform: translateY(-2px);
                }

                .variation-header {
                    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
                    padding: 1rem;
                    border-bottom: 1px solid #e9ecef;
                }

                .variation-title {
                    color: #181c32;
                    font-weight: 600;
                    font-size: 1rem;
                    margin-bottom: 0.5rem;
                }

                .variation-attributes {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 0.25rem;
                }

                .variation-attributes .badge {
                    font-size: 0.75rem;
                    padding: 0.25rem 0.5rem;
                    background-color: #e1f0ff !important;
                    color: #009ef7;
                    border: 1px solid #b3d9ff;
                }

                .variation-content {
                    padding: 1rem;
                }

                .variation-content .form-group {
                    margin-bottom: 0.75rem;
                }

                .variation-content .form-label {
                    font-size: 0.8rem;
                    font-weight: 500;
                    color: #5e6278;
                    margin-bottom: 0.25rem;
                }

                .variation-content .form-control-sm {
                    padding: 0.375rem 0.5rem;
                    font-size: 0.8rem;
                }

                /* Disabled Tab Styling */
                .nav-link:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                    background: #f8f9fa;
                }

                .nav-link:disabled:hover {
                    background: #f8f9fa;
                    color: #a1a5b7;
                }

                /* Mobile responsive for variations */
                @media (max-width: 768px) {
                    .variations-grid {
                        grid-template-columns: 1fr;
                        gap: 1rem;
                    }

                    .variation-attribute-card {
                        padding: 1rem;
                    }

                    .option-card {
                        padding: 0.5rem;
                    }

                    .variation-header {
                        padding: 0.75rem;
                    }

                    .variation-content {
                        padding: 0.75rem;
                    }

                    /* Product Details Modal Mobile */
                    .product-images-grid {
                        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
                        gap: 0.75rem;
                    }

                    .product-images-section {
                        padding: 1rem;
                    }

                    .info-section {
                        padding: 1rem;
                    }

                    .info-row {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 0.25rem;
                    }

                    .info-label {
                        min-width: auto;
                        font-size: 0.8rem;
                    }

                    .info-value {
                        text-align: left;
                        font-size: 0.8rem;
                    }

                    .modal-footer {
                        flex-direction: column;
                        gap: 1rem;
                    }

                    .product-actions,
                    .modal-actions {
                        width: 100%;
                        justify-content: center;
                    }

                    .product-actions {
                        order: 2;
                    }

                    .modal-actions {
                        order: 1;
                    }

                    .description-content {
                        max-height: 200px;
                        padding: 0.75rem;
                    }
                }

                @media (max-width: 576px) {
                    .product-images-grid {
                        grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
                        gap: 0.5rem;
                    }

                    .product-images-section {
                        padding: 0.75rem;
                    }

                    .info-section {
                        padding: 0.75rem;
                    }

                    .section-title {
                        font-size: 0.9rem;
                        margin-bottom: 0.75rem;
                    }

                    .info-row {
                        padding: 0.375rem 0;
                    }

                    .info-label {
                        font-size: 0.75rem;
                    }

                    .info-value {
                        font-size: 0.75rem;
                    }

                    .categories-display .badge {
                        font-size: 0.7rem;
                        padding: 0.375rem 0.5rem;
                    }

                    .description-content {
                        max-height: 150px;
                        padding: 0.5rem;
                        font-size: 0.8rem;
                    }

                    .modal-footer {
                        padding: 1rem;
                    }

                    .product-actions,
                    .modal-actions {
                        flex-direction: column;
                        gap: 0.5rem;
                    }

                    .product-actions .btn,
                    .modal-actions .btn {
                        width: 100%;
                        justify-content: center;
                    }
                }

                @media (max-width: 576px) {
                    .variation-attribute-card {
                        padding: 0.75rem;
                    }

                    .attribute-header .row {
                        flex-direction: column;
                    }

                    .attribute-header .col-md-6 {
                        margin-top: 1rem;
                    }

                    .option-card .row {
                        flex-direction: column;
                    }

                    .option-card .col-6,
                    .option-card .col-4,
                    .option-card .col-2 {
                        margin-bottom: 0.5rem;
                    }
                }

                /* Product Details Modal Styling */
                .modal-title-wrapper h5 {
                    color: #181c32;
                    font-weight: 600;
                }

                .modal-title-wrapper p {
                    color: #a1a5b7;
                    font-size: 0.875rem;
                }

                /* Product Images Section */
                .product-images-section {
                    background: #f8f9fa;
                    border-radius: 0.75rem;
                    padding: 1.5rem;
                    border: 1px solid #e9ecef;
                    margin-bottom: 1rem;
                }

                .product-images-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
                    gap: 1rem;
                    margin-top: 1rem;
                }

                .product-image-item {
                    position: relative;
                    border-radius: 0.5rem;
                    overflow: hidden;
                    background: white;
                    border: 1px solid #e9ecef;
                    transition: all 0.3s ease;
                    aspect-ratio: 1;
                }

                .product-image-item:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
                    border-color: #009ef7;
                }

                .product-detail-img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.3s ease;
                }

                .product-image-item:hover .product-detail-img {
                    transform: scale(1.05);
                }

                .image-overlay {
                    position: absolute;
                    top: 0.5rem;
                    right: 0.5rem;
                    background: rgba(0, 0, 0, 0.7);
                    color: white;
                    border-radius: 0.25rem;
                    padding: 0.25rem 0.5rem;
                    font-size: 0.75rem;
                    font-weight: 600;
                }

                /* Info Sections */
                .info-section {
                    background: #f8f9fa;
                    border-radius: 0.75rem;
                    padding: 1.5rem;
                    border: 1px solid #e9ecef;
                    height: 100%;
                }

                .section-title {
                    color: #181c32;
                    font-weight: 600;
                    font-size: 1rem;
                    margin-bottom: 1rem;
                    padding-bottom: 0.5rem;
                    border-bottom: 1px solid #e9ecef;
                }

                .info-table {
                    display: flex;
                    flex-direction: column;
                    gap: 0.75rem;
                }

                .info-row {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    padding: 0.5rem 0;
                    border-bottom: 1px solid #f1f3f4;
                }

                .info-row:last-child {
                    border-bottom: none;
                }

                .info-label {
                    font-weight: 600;
                    color: #5e6278;
                    font-size: 0.875rem;
                    min-width: 120px;
                    flex-shrink: 0;
                }

                .info-value {
                    color: #181c32;
                    font-size: 0.875rem;
                    text-align: right;
                    flex: 1;
                    word-break: break-word;
                }

                /* Categories Display */
                .categories-display {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 0.5rem;
                }

                .categories-display .badge {
                    font-size: 0.8rem;
                    padding: 0.5rem 0.75rem;
                    border-radius: 0.375rem;
                }

                /* Description Content */
                .description-content {
                    background: white;
                    border: 1px solid #e9ecef;
                    border-radius: 0.5rem;
                    padding: 1rem;
                    max-height: 300px;
                    overflow-y: auto;
                }

                .description-content h1,
                .description-content h2,
                .description-content h3,
                .description-content h4,
                .description-content h5,
                .description-content h6 {
                    color: #181c32;
                    font-weight: 600;
                    margin-bottom: 0.5rem;
                }

                .description-content p {
                    margin-bottom: 0.75rem;
                    line-height: 1.6;
                }

                .description-content ul,
                .description-content ol {
                    padding-left: 1.5rem;
                    margin-bottom: 0.75rem;
                }

                .description-content a {
                    color: #009ef7;
                    text-decoration: underline;
                }

                .description-content a:hover {
                    color: #0056b3;
                }

                /* Modal Footer Actions */
                .product-actions {
                    display: flex;
                    gap: 0.5rem;
                }

                .modal-actions {
                    display: flex;
                    gap: 0.5rem;
                }

                .btn-outline-secondary {
                    border-color: #e1e5e9;
                    color: #7e8299;
                }

                .btn-outline-secondary:hover {
                    background-color: #f8f9fa;
                    border-color: #d1d5db;
                    color: #181c32;
                }

                .btn-outline-danger {
                    border-color: #f1416c;
                    color: #f1416c;
                }

                .btn-outline-danger:hover {
                    background-color: #f1416c;
                    border-color: #f1416c;
                    color: white;
                }

                /* Product Thumbnail Styles */
                .product-thumbnail {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 60px;
                    height: 60px;
                    border-radius: 0.5rem;
                    overflow: hidden;
                    background: #f8f9fa;
                    border: 1px solid #e9ecef;
                }

                .product-thumb-img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.3s ease;
                }

                .product-thumb-img:hover {
                    transform: scale(1.1);
                }

                .no-image-placeholder {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    height: 100%;
                    color: #a1a5b7;
                    font-size: 1.5rem;
                }

                /* Mobile Product Thumbnail Styles */
                .product-thumbnail-mobile {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 50px;
                    height: 50px;
                    border-radius: 0.5rem;
                    overflow: hidden;
                    background: #f8f9fa;
                    border: 1px solid #e9ecef;
                    margin-right: 0.75rem;
                    flex-shrink: 0;
                }

                .product-thumb-img-mobile {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .no-image-placeholder-mobile {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    height: 100%;
                    color: #a1a5b7;
                    font-size: 1.25rem;
                }

                /* Mobile card header layout adjustment */
                .product-card-header {
                    display: flex;
                    align-items: flex-start;
                    gap: 0.75rem;
                }

                .product-title-section {
                    flex: 1;
                    min-width: 0;
                }

                .product-price {
                    flex-shrink: 0;
                }

                /* Modal Loading Overlay */
                .modal-loading-overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(255, 255, 255, 0.9);
                    z-index: 1050;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 0.5rem;
                }

                .modal-loading-overlay .spinner-border {
                    width: 3rem;
                    height: 3rem;
                }

                .modal-loading-overlay p {
                    color: #6c757d;
                    font-weight: 500;
                    margin: 0;
                }
            `}</style>
        </div>
    )
}

export default ProductList 